<template>
    <v-card>
        <v-toolbar id="header-dialogue-inbox-full" class="h-auto" content-class="h-auto">
            <div class="d-flex align-items-center">
                <div style="margin:0 20px 0 0">
                    <v-btn @click="closeDialog(true, true)"
                           class="dgs-new-button" style="width: 40px; min-width: unset !important">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </div>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 1" class="size-24 document-title">{{ $t("res_Title_CreateNewIncoming") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 2" class="size-24 document-title">{{ $t("res_Title_CreateNewOutgoing") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 3" class="size-24 document-title">{{ $t("res_Title_CreateNewInternal") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 4" class="size-24 document-title">{{ $t("res_Title_CreateNewDecree") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber == null && document.categoryId == 5" class="size-24 document-title">{{ $t("res_Title_CreateNewCircular") }}</v-toolbar-title>
                <v-toolbar-title v-if="document.referenceNumber != null" class="size-24 document-title">
                    <span class="FullView-Div-DocumentSubject" :title="subject">{{ subject }}</span>																					
                </v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-items-center toolbar-icons">

                <v-btn v-if="!isFavorite" class="dgs-new-button-icon" @click="addFavoriteDialog = true" icon v-tooltip="$t('res_Label_AddToFavorite')"><v-icon class="primary-hover">mdi-star-outline</v-icon></v-btn>
                <v-btn v-else class="dgs-new-button-icon" @click="removeFavoriteDialog = true" icon v-tooltip="$t('res_Label_RemoveFromFavorite')"><v-icon class="primary-hover">mdi-star</v-icon></v-btn>

                <div class="position-relative d-inline">
                    <v-btn class="dgs-new-button-icon" @click="ViewBarcode()" v-tooltip="$t('res_Label_Parcode')" icon><v-icon>mdi-barcode-scan</v-icon></v-btn>
                    <v-card class="barCode d-flex flex-column" v-if="barcodeFormDialog" v-click-outside="hideBarCode">
                        <div class="img-wrapper d-flex flex-column flex-1 justify-content-center">
                            <img id="barcode" :src="barcodeImage" />
                        </div>
                        <div class="text-center border-top pt-2">
                            <v-btn class="btn-text text-primary weight-500" @click="printBarcode()">Print</v-btn>
                        </div>
                    </v-card>
                </div>

                <v-btn class="dgs-new-button-icon" icon @click="createCopyFromLetter" v-tooltip="$t('res_Label_Copy')"><v-icon class="primary-hover">mdi-content-copy</v-icon></v-btn>
                <v-menu v-model="PrintOptions">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="dgs-new-button-icon" icon @click="PrintOptions= true" v-bind="attrs" v-on="on" v-tooltip="$t('res_Label_PrintOptions')">
                            <v-icon class="primary-hover">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                            <v-list>
                                <v-list-item @click="printWithAttachments">
                            <v-list-item-content>
                            <v-list-item-title>{{ $t('res_Label_Print') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="printWithAttachmentWithStamps">
                            <v-list-item-content>
                            <v-list-item-title>{{ $t('res_Label_PrintWithStamps') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="printwithoutsignture">
                            <v-list-item-content>
                            <v-list-item-title>{{ $t('res_Label_PrintWithoutheaderandfooter') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="printwithoutHeader">
                            <v-list-item-content>
                            <v-list-item-title>{{ $t('res_Label_PrintWithoutSignature') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                            </v-list>
                    </v-list>
                </v-menu>                
                <v-menu v-model="DownloadOptions">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="dgs-new-button-icon" icon @click="DownloadOptions= true" v-bind="attrs" v-on="on" v-tooltip="$t('res_Label_DownloadOptions')">
                            <v-icon class="primary-hover">mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                            <v-list>
                                <v-list-item @click="downloadWithAttachments">
                                    <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_Download') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="downloadAttachmentWithStamps">
                                    <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_DownloadWithStamps') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="downloadwithoutsignture">
                                    <v-list-item-content>
                                    <v-list-item-title>{{ $t('res_Label_DownloadWithoutheaderandfooter') }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                    </v-list>
                </v-menu>
                <div class="custom-icon-wrapper">
                    <v-icon @click="closeDialog(false, true)">custom-icon mdi-close</v-icon>
                </div>
            </div>
        </v-toolbar>
        <div class="dialog-body h-100">
            <div class="row m-0 h-100">
                <div class="form-section col-md-4 col-lg-4 p-0 m-0 h-100">
                    <!--scrollable-white container-->
                    <div class=" scrollable-container h-100 main-bg-color">
                        <div class="side-components-inner">
                            <div class="apply-button text-end inner-single-component" v-if="canEditDocumentMetaData()">
                                <v-btn text color="primary" class="p-0 btn-color-2" @click="applyChanges()" v-if="this.document.categoryId != 1">
                                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                                    {{ $t("res_ButtonText_ApplyChanges") }}
                                </v-btn>
                                <v-btn text color="primary" class="p-0" @click="applyChanges()" v-if="this.document.categoryId == 1">
                                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                                    {{ $t("res_ButtonText_Save") }}
                                </v-btn>
                            </div>
                            <div class=" inner-single-component" v-if="transferId != 0 || viewMode == 'readonly'">
                                <div class="d-flex align-items-start" v-if="document.referenceNumber == null">
                                    <div class="template_name " v-if="!utils.CheckIfNullOrEmpty(this.document.subject)">
                                        {{ this.document.subject }}
                                    </div>
                                    <v-tooltip bottom v-if="this.document.categoryId != 1 && this.selectedTemplate != null">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" class="custom-icon">
                                                mdi-help
                                            </v-icon>
                                        </template>
                                        <span>
                                            <div class="white-container p-3">
                                                <v-chip dark color="purple">{{ this.selectedTemplate.language }}</v-chip>
                                                <v-chip dark color="purple" class="mx-3">{{ this.selectedTemplate.signatureCount }} {{ $t("res_Label_Signature") }}</v-chip>
                                                <h2>{{ this.selectedTemplate.itemName }}</h2>
                                                <p>{{ this.selectedTemplate.descriptionEn }}</p>
                                            </div>
                                        </span>
                                    </v-tooltip>
                                </div>
                                <!-- controls in view mode -->
                                <div class="form-sub-section view-details-section" v-if="transferId != 0 || viewMode == 'readonly'">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h3>{{ $t("res_Label_TransferDetails") }}</h3>
                                        </div>
                                    </div>
                                    <v-divider></v-divider>
                                    <div>
                                        <div class="bg-color-buble">
                                            <div class="sender-receiver-box">
                                                <div class="text-start">
                                                    <p class="main-text-large m-0">
                                                        <label v-if="utils.getOverDue(this.document.transferOverdue, openedFromNodeId)" class="text-warning mx-2">
                                                            <v-icon>{{ utils.getOverDue(this.document.transferOverdue, openedFromNodeId)}}</v-icon>
                                                            {{ utils.getOverdueDays(this.document.transferOverdue, this.document.transferOverdueDays, openedFromNodeId) }}
                                                        </label>
                                                        {{ utils.dateFormat(document.transferDueDate) }}
                                                    </p>
                                                    <span class="action-label-new">{{ $t("res_Label_DueDate") }}</span>
                                                </div>
                                            </div>
                                            <div class="sender-receiver-box">
                                                <div>
                                                    <p class="main-text-large m-0">{{ this.document.purpose }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_Action") }}</span>
                                                </div>
                                                <div class="text-end">
                                                    <div>
                                                        <v-chip dark v-bind:class="utils.getStatusClass(this.document.statusId)">{{ utils.getStatus(this.document.statusId) }}</v-chip>
                                                    </div>
                                                    <span class="action-label-new">{{ $t('Status') }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <br />

                                        <div class="bg-color-buble">
                                            <div class="sender-receiver-box">
                                                <div>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on">
                                                                <p class="main-text-large m-0">{{ document.fromUser }}</p>
                                                            </div>
                                                        </template>
                                                        <UserInfo :userId="this.document.fromUserId" :structureId="this.document.fromStructureId"></UserInfo>
                                                    </v-tooltip>
                                                    <span class="action-label-new">{{ $t("res_Label_From") }}</span>
                                                </div>
                                                <div class="text-end">
                                                    <p class="main-text-large m-0">{{ utils.dateFormat(this.document.transferCreatedDate, '', true) }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_RecievedOn") }}</span>
                                                </div>
                                            </div>
                                            <div class="sender-receiver-box">
                                                <div>
                                                    <p class="main-text-large m-0" style="max-width: 175px;">{{ this.document.referenceNumber }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_ReferencenNo") }}</span>
                                                </div>
                                                <div>
                                                    <div class="text-end">
                                                        <p class="dark-title size-16 text-end m-0 text-limit" v-tooltip="this.document.instruction">{{ this.document.instruction }}</p>
                                                        <span class="action-label-new">{{ $t("res_Label_Notes") }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <br v-if="!canEditDocumentMetaData()" />
                                        <div class="bg-color-buble" v-if="!canEditDocumentMetaData()">
                                            <div class="sender-receiver-box">
                                                <div v-if="!canEditDocumentMetaData()">
                                                    <p class="main-text-large m-0">{{ this.document.fromStructure }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_Sender") }}</span>
                                                </div>
                                                <div class="text-end" v-if="!canEditDocumentMetaData()">
                                                    <p class="dark-title size-16 text-end m-0 " :class="utils.getPriorityClassColor(this.document.priorityId)">
                                                        {{ utils.getPriorityName(this.document.priorityId) }}
                                                    </p>
                                                    <span class="action-label-new">{{ $t("res_Label_Priority") }}</span>
                                                </div>
                                            </div>
                                            <div class="sender-receiver-box">
                                                <div v-if="!canEditDocumentMetaData()">
                                                    <p class="main-text-large m-0">{{ utils.getPrivacyName(this.document.privacyId) }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_Privacy") }}</span>
                                                </div>
                                                <div class="text-end" v-if="!canEditDocumentMetaData()">
                                                    <p class="main-text-large m-0">{{ utils.dateFormat(this.document.dueDate) }}</p>
                                                    <span class="action-label-new">{{ $t("res_Label_DocumentDueDate") }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <br v-if="!canEditDocumentMetaData() && constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTags.key)" />

                                        <div class="bg-color-buble" v-if="!canEditDocumentMetaData() && constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTags.key)">
                                            <div class="sender-receiver-box mt-3">
                                                <div>
                                                    <div v-for="tag in document.tags" :key="tag" style="display:inline;">
                                                        <span v-if="tag.id != -1" class="main-text-large mr-2 p-1 border rounded-lg border-dark">{{ tag.name }}</span>
                                                    </div>
                                                    <p class="action-label-new mt-3">{{ $t("res_Label_Tags") }}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <br v-if="!canEditDocumentMetaData()" />
                                         <div class="bg-color-buble" v-if="!canEditDocumentMetaData() && document.categoryId==6">
                                         
                                            <div class="sender-receiver-box">
                                                <div>
                                                    <p v-if="isLanguageEn"class="main-text-large m-0" style="max-width: 175px;">{{ this.document.Committee.councilName }}</p>
                                                     <p v-else class="main-text-large m-0" style="max-width: 175px;">{{ this.document.Committee.councilNameAr }}</p>
                                                   
                                                    <span class="action-label-new">{{ $t("res_Committee_MeetingForm") }}</span>
                                                </div>
                                             
                                            </div>
                                           
                                        </div>

                                         <br v-if="!canEditDocumentMetaData()" />
                                         <div class="bg-color-buble" v-if="!canEditDocumentMetaData() && document.categoryId==6">
                                         
                                            <div class="sender-receiver-box">
                                                
                                                <div class="col-md-12" >
                                              
                                                <p>
                                                  <v-data-table
                                                            :headers="Users_Headers"
                                                            :items="sortedCouncilUsers"
                                                            item-key="id"
                                                            class="position-relative white flex-1 d-flex overflow-auto"

                                                            id="usersTable"
                                                            :mobile-breakpoint="0"
                                                            disable-sort
                                                            loading-text="loading..."
                                                            :no-data-text="$t('res_Label_NoData')"
                                                            :footer-props="{'items-per-page-text': 'Items per page'}"
                                                            caption=""
                                                            hide-default-footer
                                                            header-fixed
                                                            
                                                            >
                                                            <!-- Data for Each Row -->
                                                            <template v-slot:item="row">
                                                                <tr :style="{ backgroundColor: '#f0f8ff'  }">
                                                                    <td class="text-center" :style="{ zIndex: 0 }">
                                                                        <v-checkbox
                                                                            v-model="selectedItems"
                                                                            :value="row.item.id"
                                                                           
                                                                            class="ckStyle"
                                                                            :disabled="true"
                                                                        ></v-checkbox>
                                                                    </td>
                                                                    <td class="text-center">{{ row.item.title }}</td>
                                                                    <td class="text-center">{{ row.item.titleAr }}</td>
                                                                    <td class="text-center">{{ row.item.isHead ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td>
                                                                    <td class="text-center">{{ row.index + 1 }}</td>
                                                                    <td class="text-center" >					
                                                                        <v-text-field
                                                                            v-model="row.item.Task"
                                                                            type="text"
                                                                            class="task-input custom-task-field"
                                                                            :disabled="true"
                                                                            dense
                                                                            style="width:38px;height:38px; background-color: white; border-radius: 4px;"
                                                                            outlined
                                                                        ></v-text-field>
                                                                    </td>
                            
                                                                </tr>
                                                            </template>

                                                        </v-data-table>
                                                 <p/>  
                                                  <span class="action-label-new">{{ $t("res_MeetingForm_Attendees") }}</span>

                                                </div>
                                               
                                                 
                                             
                                            </div>
                                           
                                        </div>



                                     



                                        <br v-if="!canEditDocumentMetaData()" />

                                        <div class="bg-color-buble" v-if="!canEditDocumentMetaData()  && document.categoryId==6"">
                                            <div class="sender-receiver-box mt-3">
                                                <div>
                                                    <div v-for="guest in document.Guests" :key="guest" style="display:inline;">
                                                        <span v-if="guest.id > 0" class="main-text-large mr-2 p-1 border rounded-lg border-dark">{{ guest.name }}</span>
                                                    </div>
                                                    <p class="action-label-new mt-3">{{ $t("res_Label_Guests") }}</p>
                                                </div>
                                            </div>
                                        </div>
                                          <br v-if="!canEditDocumentMetaData()"  />

                                        <div class="bg-color-buble" v-if="constants.client_version_Id=='NLA' && !canEditDocumentMetaData()">
                                            <div class="sender-receiver-box">
                                                <div>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on">
                                                                <p class="main-text-large m-0">{{ document.deliveryTypes.Name }}</p>
                                                            </div>
                                                        </template>
                                                    </v-tooltip>
                                                    <span class="action-label-new">{{ $t("res_Label_DeliveryTypes") }}</span>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <br v-if="!canEditDocumentMetaData()" />
                                        <div>
                                            <!-- Dynamic Forms -->
                                            <DynamicFormRender ref="formStructureAndCategory" :formId="dynamicFormByStructureIdAndCategoryId" :filters="filterByStructureIdAndCategoryId" :documentData="document.structureForm"></DynamicFormRender>
                                            <DynamicFormRender ref="formTemplate" :formId="dynamicFormByTemplateId" :filters="filterByTemplateId" :documentData="document.templateForm"></DynamicFormRender>
                                        </div>
                                  
                                  
                                    </div>
                                </div>
                            </div>

                            <!-- controls in create mode -->
                            <div class="inner-single-component" v-if="canEditDocumentMetaData()">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h3 class="main-text-large mb-0 ml-2 mr-2">{{$t("res_GridHeaders_Details")}}</h3>
                                </div>
                                <v-divider></v-divider>
                                <div class="row">
                                    <div class="col-md-12" v-if="user_structures.length > 1" style="display: block">
                                        <label>{{ $t("res_Label_RegisterFrom") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="user_structure" label="structureName" track-by="structureId"
                                                          open-direction="bottom" :options="user_structures" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false" :placeholder="$t('res_Label_SelectOption')">
                                                <template slot="noOptions" slot-scope="props">
                                                    {{ $t("res_Msgs_EmptySearch") }}
                                                </template>
                                            </multi-select>
                                        </div>
                                    </div>
                                    <!--Designated Persons Conponent-->
                                    <RecipientSenderSelector 
                                                       :sendingEntityId="document.sendingEntityId"
                                                       :senderDesignatedPersonsId="document.sendingDesignatedPersonId"
                                                       :receiversAndDesignatedPersons="document.receiversAndDesignatedPersons"
                                                       :categoryId="this.document.categoryId"
                                                       @exportedData="fillSenderRecipientDesignatedPersonsData"
                                                       :currentStructureId="this.user_structure.structureId">
                                    </RecipientSenderSelector>
                                    <div class="col-md-12" v-if="this.document.categoryId != 1">
                                        <label class="label_required">{{ $t("res_Label_CC") }}</label>
                                        <div class="d-flex align-items-center">
                                            <div class="with-absolute-button flex-1">
                                                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                                                       :showInternalStructures="true" :showExternalStructures="false" :ignorePermissions="document.categoryId != 3"
                                                                       :excludeSelf="true" :isMultiple="true" :selectedStructureUsersList="document.cc"
                                                                       @structureUserSelectChanged="documentCCSelectedChange" :calledFromField="('DocCC')">
                                                </StructureUserSelector>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>{{ $t("res_Label_Priority") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.priority" label="name" track-by="id"
                                                          open-direction="bottom" :options="priority_items" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                                          @select="priorityChanged" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(1)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>{{ $t("res_Label_Privacy") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.privacy" label="name" track-by="id"
                                                          open-direction="bottom" :options="privacy_items" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                                          ref="multiselect2" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(2)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-sm-6" v-if="isImportanceFieldVisible">
                                        <label>{{ $t("res_Label_Importance") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.importance" label="name" track-by="id"
                                                open-direction="bottom" :options="importance_items" :searchable="true"
                                                :loading="loading" :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect3" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(3)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-sm-6" v-if="constants.showDocumentType">
                                        <label>{{ $t("DocumentType") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.documentType" label="name" track-by="id"
                                                open-direction="bottom" :options="documentType_items" :searchable="true"                                                        
                                                :loading="loading" :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect21" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(21)"><v-icon>mdi-menu-down</v-icon></button>															   
                                        </div>																										   
                                        </div>
                                    <div class="col-12" v-if="this.document.categoryId == 1">
                                        <label class="label_required">{{ $t("res_Label_DocumentNumber") }} *</label>
                                        <v-text-field v-model="document.externalReferenceNumber" label="" solo></v-text-field>
                                    </div> 
                                    <div class="col-sm-12">
                                        <label class="label_required"> {{constants.isMOMEnabled && this.document.categoryId == 6 ? $t("res_CommitteeSelected_MeetingDate"): $t("res_Label_DocumentDate") }} * </label>
                                        <v-menu content-class="p-0" v-model="document_date_menu" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedDate" label="" readonly v-bind="attrs" v-on="on"
                                                              solo append-icon="mdi-calendar">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="document.date" @input="document_date_menu = false"
                                                           :max="nowDate"></v-date-picker>
                                        </v-menu>
                                    </div>                                 
										
                                    <div class="col-sm-12" v-if="viewIncomingAddedFields">
                                        <label class="label_required">{{ $t("res_Label_ReceivedDate") }}</label>
																		  
                                        <v-menu content-class="p-0" v-model="document_receivedDate_menu" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedReceivedDate" label="" readonly v-bind="attrs" v-on="on"
                                                            solo append-icon="mdi-calendar">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="document.receivedDate" @input="document_receivedDate_menu = false"></v-date-picker>
                                        </v-menu>
                                    </div>

                                    <div class="col-sm-12" v-if="viewOutgoingAddedFields"> 
                                        <label class="label_required">{{ $t("res_Label_PrintingOptions") }}</label>  
                                        <v-radio-group class="bg-white" v-model="multiDocument"> 
                                            <v-row no-gutters class="bg-white">
                                                <v-col cols="6" class="mb-6"> 
                                                    <v-radio :label="PrintingOptionsMultiplelbl" value="1"></v-radio>
                                                </v-col>
                                                <v-col cols="6" class="mb-6"> 
                                                    <v-radio :label="PrintingOptionsSinglelbl" value="0"></v-radio>
                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </div>


                                    <div class="col-sm-12" v-if="viewIncomingAddedFields">
                                        <label class="label_required">{{ $t("res_Label_MessageType") }}</label>
                                        <multi-select class="light-bg" v-model="document.messageType" :label="selectedLang == 'en' ? 'Name' : 'NameAr'" track-by="Id"
                                                        open-direction="bottom" :options="messageType_items" :searchable="true"
                                                        :loading="loading" :internal-search="false" :clear-on-select="false"
                                                        :close-on-select="true" :options-limit="300" :max-height="600"
                                                        :show-no-results="false" :hide-selected="false" :multiple="false"
                                                        ref="multiselect2" :placeholder="$t('res_Label_MessageType')">
                                        </multi-select>
                                    </div>
 
                                    <div class="col-sm-12">
                                        <label class="label_required">{{ $t("res_Label_DueDate") }} *</label>
                                        <v-menu content-class="p-0" v-model="document_due_date_menu" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="formattedDueDate" label="" readonly v-bind="attrs" v-on="on"
                                                              solo append-icon="mdi-calendar">
                                                    <template v-slot:append>
                                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="document.dueDate" @input="document_due_date_menu = false"
                                                           :min="nowDate"></v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div class="col-sm-12" v-if="constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTags.key)">
                                        <label>{{ $t("res_Label_Tags") }}</label>
                                        <multi-select class="light-bg" v-model="document.tags" label="name" track-by="id"
                                                      open-direction="bottom" :options="tagOptions" :searchable="true"
                                                      :loading="loading" :clear-on-select="false" @search-change="searchTags"
                                                      :close-on-select="false" :options-limit="300" :max-height="600"
                                                      :show-no-results="false" :hide-selected="false" :multiple="true"
                                                      :taggable="true" @tag="addTag"
                                                      ref="multiselect5" :placeholder="$t('res_Label_SelectOption')">
                                        </multi-select>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <label class="label_required"> {{constants.isMOMEnabled && this.document.categoryId == 6 ? $t("res_CommitteeSelected_MeetingTitle"): $t("res_Label_Subject") }} * </label>
                                            </div>
                                            <div class="text-center position-relative">
                                                <v-menu offset-y :close-on-content-click="false" attach :left="!$vuetify.rtl" :right="$vuetify.rtl" class="white-background">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <button class="more-list d-flex align-items-center" v-bind="attrs" v-on="on">
                                                            {{ $t("res_ButtonText_More") }} <v-icon class="light">mdi-chevron-down</v-icon>
                                                        </button>
                                                    </template>
                                                    <v-list class="checkbox-select-list" dense>
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showTranslatedSubjectBlock" :label="TranslatedSubjectLabel" class="bg-white"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showKeywordsBlock" :label="KeywordsLabel"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item>
                                                            <v-list-item-title>
                                                                <v-checkbox v-model="showOtherAttachmentsBlock" :label="OtherAttachmentsLabel"></v-checkbox>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-divider></v-divider>
                                                        <v-list-item>
                                                            <a class="clear-btn" @click="clearBlockSelections()">{{ $t("res_ButtonText_Clear") }}</a>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                        </div>
                                        <v-textarea v-model="document.subject" label="" class="light-bg  subject-txt" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                                    </div>

                                    <template v-if="constants.showFilingClassificationPlanSections">
                                        <div class="col-md-12" style="display: block">
                                            <label>{{ $t("res_label_FilingPlan") }} </label>
                                            <FilingClassificationPlanSelector :mode="filingClassificationPlanMode.FilingPlanMode" 
                                                                              :selectedFilingPlan="document.filingPlan"
                                                                              @FilingPlanSelectChanged="filingPlanSelectChanged">
                                            </FilingClassificationPlanSelector>
                                        </div>
                                       <div class="col-md-12" style="display: block">
                                            <label>{{ $t("res_label_ClassificationPlan")}}</label>
                                            <FilingClassificationPlanSelector :mode="filingClassificationPlanMode.ClassificationPlanMode"
                                                                                :selectedClassificationPlan="document.classificationPlan"
                                                                                @ClassificationPlanSelectChanged="classificationPlanSelectChanged">
                                            </FilingClassificationPlanSelector>
                                      </div>
                                    </template>
                                   

                                    <template v-if="constants.showReplyNeedReply">
                                        <span class="col-md-12 d-flex align-items-center" v-if="this.document.categoryId == 2">
                                            <v-checkbox v-model="document.isNeedReply" class="mt-1"></v-checkbox>
                                            <span class="">{{ $t("res_Label_NeedReply") }}</span>
                                        </span>
                                        <template v-if="this.document.categoryId == 1">
                                            <span class="d-flex align-items-center">
                                                <v-checkbox v-model="showReplyDocumentSection" @click="handleShowReplyDocumentSection" class="mt-1"></v-checkbox>
                                                <span class="">{{ $t("res_Label_Reply") }}</span>
                                            </span>
                                            <div class="col-md-12 mb-0 mb-3" v-if="showReplyDocumentSection">
                                                <div class="d-flex align-items-center">
                                                    <div class="with-absolute-button flex-1">
                                                        <DocumentSelector :selectedDocument="document.replyDocument"
                                                                          @DocumentSelectChange="replyDocumentSelectedChange">
                                                        </DocumentSelector>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>

                                    <div class="col-sm-12" v-if="showWorkflowFeature">
                                        <label>{{ $t("res_Label_ChooseWorkflow") }} </label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.workflow" label="name" track-by="id" open-direction="bottom" :options="workflow_items" :searchable="true"
                                                    :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                                    :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect7" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(7)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>

                                    <div>
                                        <div>
                                            <!-- Dynamic Forms -->
                                            <DynamicFormRender ref="formStructureAndCategory" :formId="dynamicFormByStructureIdAndCategoryId" :filters="filterByStructureIdAndCategoryId" :documentData="document.structureForm"></DynamicFormRender>
                                            <DynamicFormRender ref="formTemplate" :formId="dynamicFormByTemplateId" :filters="filterByTemplateId" :documentData="document.templateForm"></DynamicFormRender>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-if="constants.client_version_Id == 'DDA' && (constants.categories_has_configure_signature.indexOf(this.document.categoryId) == -1 || this.document.categoryId == 2 || this.document.categoryId == 3)">
                                        <label class="label_required">{{ $t("res_Label_SendAfterSigne") }}</label>
                                        <div class="d-flex align-items-center">
                                            <div class="with-absolute-button flex-1">
                                                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false" showAllInternal="true"
                                                                       :showInternalStructures="true" :showExternalStructures="false"
                                                                       :excludeSelf="false" :isMultiple="true" :ignorePermissions="document.categoryId !== 3"
                                                                       :selectedStructureUsersList="document.send_after_sign"
                                                                       @structureUserSelectChanged="documentSendAfterSignSelectedChange" :calledFromField="('SendAfterSign')">
                                                </StructureUserSelector>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12" v-if="showTranslatedSubjectBlock">
                                        <label>{{ $t("res_Label_TranslatedSubject") }}</label>
                                        <v-textarea v-model="document.translatedSubject" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                                    </div>
                                    <div class="col-md-12" v-if="showKeywordsBlock">
                                        <label>{{ $t("res_Label_Keywords") }}</label>
                                        <v-textarea v-model="document.keywords" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                                    </div>
                                    <div class="col-md-12" v-if="showOtherAttachmentsBlock">
                                        <label>{{ $t("res_Label_OtherAttachments") }}</label>
                                        <v-textarea v-model="document.otherAttachments" label="" class="light-bg" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                                    </div>
                                    <div class="col-md-6" v-if="constants.client_version_Id == 'ADFD' && this.document.categoryId == 3 && this.showProjectGroup">
                                        <label>{{ $t("res_Label_Country") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.country" track-by="Id"
                                                          :label="constants.client_version_Id == 'ADFD' ? 'Name' : 'NameAr'"
                                                          open-direction="bottom" :options="constants.countriesList" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                                          ref="multiselect15" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(15)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="constants.client_version_Id == 'ADFD' && this.document.categoryId == 3 && this.showProjectGroup">
                                        <label>{{ $t("res_Label_ProjectName") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.project" track-by="Id"
                                                          :label="constants.client_version_Id == 'ADFD' ? 'Name' : 'NameAr'"
                                                          open-direction="bottom" :options="constants.projectsList" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                                          ref="multiselect16" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(16)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-if="constants.client_version_Id == 'ADFD' && this.document.categoryId == 3 && this.showProjectGroup">
                                        <label>{{ $t("res_Label_ProjectNumber") }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.projectNumber" track-by="Id"
                                                          :label="constants.client_version_Id == 'ADFD' ? 'Name' : 'NameAr'"
                                                          open-direction="bottom" :options="constants.projectsNumbersList" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="false" :hide-selected="false" :multiple="false"
                                                          ref="multiselect17" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(17)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div>
                                     <div class="col-md-12" v-if="constants.client_version_Id == 'NLA' && this.document.categoryId != 1">
                                        <label>{{ $t("res_Label_DeliveryTypes") }}{{ (constants.mandatoryDeliveryType && document.categoryId != 1) ?'*':''  }}</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.deliveryTypes" track-by="Id"
                                                          :label="constants.client_version_Id == 'NLA' ? 'Name' : 'NameAr'"
                                                          open-direction="bottom" :options="constants.deliveryTypesList" :searchable="true"
                                                          :loading="loading" :internal-search="false" :clear-on-select="false"
                                                          :close-on-select="true" :options-limit="300" :max-height="600"
                                                          :show-no-results="true" :hide-selected="false" :multiple="false"
                                                          ref="multiselect18" :placeholder="$t('res_Label_SelectOption')">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(18)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                    </div> 
                                    <div class="col-sm-12" v-if="constants.client_version_Id == 'NLA' && showNLA_Email">
                                            <label class="label_required">{{ $t("Email") }} *</label> 
                                            <v-text-field v-model="document.email" :label="emailLabel" solo ></v-text-field>
                                    </div>

                                    <div class="col-sm-12" v-if="constants.client_version_Id == 'NLA' && showNLA_Fax">
                                            <label class="label_required">{{ $t("res_Label_Fax") }}</label>
                                            <v-text-field v-model="document.fax" label="" solo></v-text-field>
                                    </div> 
                                    
                                    <div class="col-md-12" v-if="constants.isMOMEnabled &&  this.document.categoryId== 6" >
                                        <label>{{ $t("res_Committee_MeetingForm") }} *</label>
                                        <div class="with-absolute-button">
                                            <multi-select class="light-bg" v-model="document.Committee" label="councilName" track-by="id"
                                                open-direction="bottom" :options="Committee_items" :searchable="true"
                                                :loading="loading" :internal-search="false" :clear-on-select="false"
                                                :close-on-select="true" :options-limit="300" :max-height="600"
                                                :show-no-results="false" :hide-selected="false" :multiple="false"
                                                ref="multiselect3" :placeholder="$t('res_Label_SelectOption')" 
                                                @select="onSelectCommittee"  :disabled="disabled">
                                            </multi-select>
                                            <button @click="openMultiSelectCtrl(3)"><v-icon>mdi-menu-down</v-icon></button>
                                        </div>
                                     </div>
                                     <div class="col-md-12" v-if="constants.isMOMEnabled && this.document.categoryId== 6" >
                                        <label>{{ $t("res_MeetingForm_Attendees") }}</label>
                                        <v-data-table
                                            :headers="Users_Headers"
                                            :items="sortedCouncilUsers"
                                            item-key="id"
                                            class="position-relative white flex-1 d-flex overflow-auto"

                                            id="usersTable"
                                            :mobile-breakpoint="0"
                                            disable-sort
                                            loading-text="loading..."
                                            :no-data-text="$t('res_Label_NoData')"
                                            :footer-props="{'items-per-page-text': 'Items per page'}"
                                            caption=""
                                            hide-default-footer
                                            header-fixed
                                            
                                            >
                                            <!-- Data for Each Row -->
                                            <template v-slot:item="row">
                                                <tr :style="{ backgroundColor: selectedItems.includes(row.item.id) ? '#f0f8ff' : '' }">
                                                    <td class="text-center" :style="{ zIndex: 0 }">
                                                        <v-checkbox
                                                            v-model="selectedItems"
                                                            :value="row.item.id"
                                                            @change="moveToLast(row.item)"
                                                            class="ckStyle"
                                                            :disabled="disabled"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">{{ row.item.title }}</td>
                                                    <td class="text-center">{{ row.item.titleAr }}</td>
                                                    <td class="text-center">{{ row.item.isHead ? $t("res_ButtonText_Yes") : $t("res_ButtonText_No") }}</td>
                                                    <td class="text-center">{{ row.index + 1 }}</td>
					                                <td class="text-center" >					
                                                        <v-text-field
                                                            v-model="row.item.Task"
                                                            type="text"
                                                             class="task-input custom-task-field"
                                                            :disabled="disabled"
                                                            dense
                                                            style="width:90px;height:38px; background-color: white; border: 1px solid #ccc; border-radius: 4px;"
                                                            outlined
                                                        ></v-text-field>
                                                    </td>
			
                                                </tr>
                                            </template>

                                        </v-data-table>


                                     </div>
                                     <div class="col-md-12" v-if="constants.isMOMEnabled &&  this.document.categoryId == 6" >
                                        <label class="label_required">{{ $t("res_Label_Guests") }}</label>
                                        <div class="d-flex align-items-center">
                                            <div class="with-absolute-button flex-1">
                                                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="true"
                                                                       :showInternalStructures="false" :showExternalStructures="false"
                                                                       :excludeSelf="true" :isMultiple="true" :selectedStructureUsersList="document.Guests"
                                                                       @structureUserSelectChanged="documenSelectedGuestsChange" 
                                                                       addressBook_header="$t('res_Label_SelectGuests')"
                                                                       :disabled="disabled">
                                                </StructureUserSelector>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--signee-->
                             <div class=" inner-single-component" v-if="canEditDocumentMetaData() && ( (this.document.categoryId == 3 && selectedTemplate !== null && selectedTemplate.isWorkflow == true) || getCanBeSignedByExternalUser() || (selectedTemplate == null && constants.client_version_Id == 'DDA' && constants.categories_has_configure_signature.indexOf(this.document.categoryId) == -1))"> 

                                
                                 <div v-if="canEditDocumentMetaData() && ( (this.document.categoryId == 3 && selectedTemplate !== null && selectedTemplate.isWorkflow == true) || getCanBeSignedByExternalUser() || (selectedTemplate == null && constants.client_version_Id == 'DDA' && constants.categories_has_configure_signature.indexOf(this.document.categoryId) == -1))"> 
                                   
                                     <div class="d-flex justify-content-between align-items-center">
                                        <div class="margin-right-auto">
                                            <h3 class="main-text-large">{{ $t("res_Label_Signees") }}</h3>
                                        </div>
                                        <v-btn v-if="(selectedTemplate == null && constants.client_version_Id == 'DDA') || getCanBeSignedByExternalUser()" class="dgs-new-button ml-2 mr-2" @click="addNewSignee">{{$t('Add')}}</v-btn>
                                    </div>
                                    <v-divider v-if="this.document.signers.length > 0"></v-divider>
                                    <Container drag-handle-selector=".column-drag-handle" drag-class="opacity-ghost" @drop="signeesOnDrop">
                                        <Draggable class="col-md-12 p-0" v-for="(item, index) in this.document.signers" :key="index" drag-handle-selector=".column-drag-handle">
                                            <label class="label_required" style="cursor:pointer">{{ $t("res_Label_Signee") }} {{ index + 1 }} *</label>
                                            <div class="d-flex align-items-center column-drag-handle">
                                                <v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
                                                <div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
                                                    <StructureUserSelector :showInternalUsers="true" :showExternalUsers="(selectedTemplate == null && document.categoryId == 2) || (selectedTemplate != null && selectedTemplate.form != null && getCanBeSignedByExternalUser())" :showInternalStructures="false"
                                                                           :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                                                           :isForSignee="true" :ignorePermissions="document.categoryId !== 3"
                                                                           :selectedStructureUser="item.index && !item.id ? undefined : item" :dataToPassOnSelectChange="index"
                                                                           @structureUserSelectChanged="documentSigneeSelectedChange"
                                                                           :addressBook_header="$t('res_Label_SelectSignee')" :calledFromField="('CalledFromSignee')">
                                                    </StructureUserSelector>
                                                </div>
                                                <v-icon v-if="selectedTemplate == null && constants.client_version_Id == 'DDA'" style="bottom: 10px; cursor: pointer;"
                                                        @click="deleteSignee(index)">mdi-delete</v-icon>
                                            </div>
                                        </Draggable>
                                    </Container>
                                 </div>
                            </div> 
                            
                        </div>  

                        <br />
                        <!-- attachments -->
                        <div class=" inner-single-component">
                            <div class="form-sub-section attachments-section" v-bind:class="{ 'view-mode': !canAddEditAttachments() }">
                                <div>
                                    <v-row>
                                        <v-col class="d-flex justify-content-between align-items-center">
                                            <span class="margin-right-auto">
                                                <h3 class="main-text-large">{{ $t("res_CardHeaders_Attachments") }}</h3>
                                            </span>
                                            <v-menu v-model="isMenuOpen" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" class="dgs-new-button ml-2 mr-2" v-if="canAddEditAttachments()">
                                                        <div class="d-flex align-center">
                                                            <span>{{ $t("res_ButtonText_Upload_Scan") }}</span>
                                                            <span v-if="!isMenuOpen" class="arrow-down ml-1"></span>
                                                            <span v-else class="arrow-up ml-1"></span>
                                                        </div>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item @click="performAction('Upload')">
                                                        <v-list-item-title>{{ $t("res_ButtonText_Upload") }}</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="performAction('Scan')"  v-if="!showDWTLicenseMessage" >
                                                        <v-list-item-title>{{ $t("res_Label_Scan") }}</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider></v-divider>
                                <div>
                                    <Attachments ref="attachmentCtrl" :documentId="documentId" :transferId="transferId"
                                        :documentSubject="document.subject"
                                        :viewMode="canAddEditAttachments() ? 'edit' : 'readonly'" :categoryId="document.categoryId" :nodeId="openedFromNodeId"
                                        :document="document" :delegationId="delegationId" :isOutgoingByFile="isOutgoingByFile()" @setViewerUrl="setViewerUrl"></Attachments>
                                </div>             
                            </div>
                        </div>

                        <br />
                        <!-- notes -->
                        <div class="inner-single-component">
                            <Notes :documentId="documentId" :transferId="transferId" :viewMode="canAddEditNotes() ? 'edit' : 'readonly'"></Notes>
                        </div>

                        <br />
                        <!--Linked mails-->
                        <div class="inner-single-component">
                            <div class="form-sub-section linked-mails-section" style="display: block">
                                <div class="d-flex main-text-large justify-content-between">
                                    <span class="margin-right-auto">
                                        <h3>{{ $t("res_CardHeaders_LinkedEmails") }}</h3>
                                    </span>
                                    <v-btn class="dgs-new-button ml-2 mr-2" @click="addLinkedDocuments" v-if="canAddEditLinkedDocuments()">{{ $t("res_ButtonText_Add")}}</v-btn>
                                </div>
                                <v-divider v-if="linkedDocumentsFullList.length > 0"></v-divider>
                                <div v-bind:class="{ 'with-view-all' : linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay }">
                                    <v-list>
                                        <v-list-item class="text-hover-list" v-for="(item, i) in linkedDocuments" :key="i" @dblclick.stop.prevent="displayLinkedItem(item)">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <div class="d-flex flex-row align-items-center">
                                                            <div class="subject flex-1 overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ item.subject }}
                                                            </div>
                                                        </div>
                                                    </v-list-item-title>
                                                    <v-list-item-title>
                                                        <div class="d-flex flex-row align-items-center">
                                                            <div slot-scope="" class="reference flex-1 overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ item.referenceNumber }}
                                                            </div>
                                                        </div>
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        <div class="uploaded-by overflow-hidden text-nowrap overflow-ellipsis">
                                                            {{ $t("res_SubTitle_UploadedBy") }} {{ item.createdByUser }}
                                                        </div>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <div class="created-date">
                                                    {{ utils.formatDateTime(item.createdDate) }}
                                                </div>
                                                <div class="custom-icon-wrapper">
                                                    <v-icon @click="openLinkedEmailDeleteConfirmation(item.id)"
                                                            v-if="canAddEditLinkedDocuments() && item.isEditable">custom-icon white-bg delete-icon</v-icon>
                                                </div>
                                            </div>
                                        </v-list-item>
                                    </v-list>

                                    <v-divider class="view-all-divider" v-if="linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay"></v-divider>
                                    <div class="view-all-wrapper d-flex justify-content-center align-content-center" v-if="linkedDocumentsFullList.length > defaultNumberOfLinkedDocumentsToDisplay">
                                        <button class="view-all-btn d-flex align-items-center" @click="viewAllLinkedDocuments()" v-if="numberOfLinkedDocumentsToDisplay != 1000">
                                            {{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
                                        </button>
                                        <button class="view-all-btn d-flex align-items-center" @click="viewAllLinkedDocuments()" v-if="numberOfLinkedDocumentsToDisplay == 1000">
                                            {{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <!-- Transfers -->
                        <div class="inner-single-component" v-if="this.transferId > 0">
                            <TransferList :documentId="documentId" :toUserId="toUserId" v-if="this.transferId != 0"></TransferList>
                        </div>

                        <br />
                        <!-- Dispatch Info -->
                        <div class="inner-single-component" v-if="this.transferId > 0 && showDispatchInfoComponent && this.document.categoryId == 2">
                            <DispatchInfo :documentId="documentId" v-if="this.transferId > 0 && showDispatchInfoComponent && this.document.categoryId == 2"></DispatchInfo>
                        </div>
                    </div>
                </div>

                <div class="viewer-wrapper col-md-8 col-lg-8 h-100 p-0 m-0">
                    <!--viewer section-->
                    <div class="d-flex flex-column h-100">
                        <div class="p-0 scrollable-container flex-1 overflow-hidden">
                            <div v-if="empty_viewer" class="empty-viewer">
                                <img src="/assets/images/icons/no_preview.svg" />
                                <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                            </div>
                            <div v-if="!empty_viewer" id="viewer_template" class="h-100">
                                <iframe id="viewerFrame" :src="viewerFrameSrc" class="h-100 w-100"></iframe>
                            </div>
                        </div>

                        <!--Actions buttons-->
                        <div class="dialog-footer sticky-footer top-shadow p-3 d-flex align-items-center justify-content-between  position-relative" style="gap:0; margin-bottom:20px">
                            <div class=" d-flex align-items-center justify-content-start">
                                <TransferNotesIcon ref="transferNotesIcon" v-if="transferId != 0"></TransferNotesIcon>
                                <!--Icons Mode-->
                                <div class="actions_container3 d-flex" style="gap: 0; padding-left: 5px;" v-if="constants.showIconsInsteadOfButtonsInCreateDocumentView">
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('ResetDocument', document, transferId, delegationId , openedFromNodeId)" @click="resetDocument()" v-tooltip="$t('res_Tooltip_ResetDocument')"><v-icon style="color: #009639;">mdi-backup-restore</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('ForceGenerateReferenceNumber', document, transferId, delegationId , openedFromNodeId)" @click="forceGenerateReferenceNumber()" v-tooltip="$t('res_Tooltip_GenerateReferenceNumber')"><v-icon style="color: #009639;">mdi-weather-lightning</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('PublishToMultiDocument', document, transferId, delegationId , openedFromNodeId)" @click="PublishToMultiDocument" v-tooltip="$t('res_ButtonText_PublishToMultiDocument')"><v-icon>mdi-publish</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Preview', document, transferId, delegationId , openedFromNodeId)" @click="previewSignature" v-tooltip="$t('res_ButtonText_Review') && this.document.categoryId !== 1"><v-icon>mdi-eye-refresh-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Sign', document, transferId, nodeDelegationId , openedFromNodeId, document.canSign,0,isContainedInSignerList)" @click="signDocument" v-tooltip="$t('res_ButtonText_Sign')"><v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;</v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Approve', document, transferId, delegationId , openedFromNodeId)" @click="ApproveDocument" v-tooltip="$t('res_ButtonText_Approve')"><v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;</v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('CreateOutgoing', document, transferId, delegationId , openedFromNodeId)" @click="CreateReplyLetter" v-tooltip="$t('res_ButtonText_Reply')"><v-icon >mdi-reply</v-icon>&nbsp;</v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('SignAndSend', document, transferId, delegationId , openedFromNodeId, document.canSign,0,isContainedInSignerList)" @click="OpenTransferForm('Sign')" v-tooltip="$t('res_ButtonText_SignAndSend')"><v-icon style="color: #009639;">mdi-signature-freehand</v-icon>&nbsp;</v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Reject',document,transferId, delegationId , openedFromNodeId, document.canSign)" @click="OpenTransferForm('Rejected')" v-tooltip="$t('res_ButtonText_Reject')"><v-icon class="custom-icon">mdi-close-circle</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Forward', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Forward')" v-tooltip="$t('res_ButtonText_Forward')"><v-icon>mdi-share-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('ForwardCc', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('ForwardCc')" v-tooltip="$t('res_ButtonText_ForwardCC')"><v-icon>mdi-share-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Endorse', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Endorse')" v-tooltip="$t('res_ButtonText_Endorse')"><v-icon>mdi-email-plus-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('SendBack', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Send Back')" v-tooltip="$t('res_ButtonText_SendBack')"><v-icon>mdi-backburger</v-icon></v-btn>      
                                    <v-btn class="dgs-new-button-icon" v-if="!isArchived && utils.ActionsPermission('Archive', document, transferId, delegationId , openedFromNodeId)" @click="openCompleteDocumentDialog()" v-tooltip="$t('res_ButtonText_Archive')"><v-icon>mdi-archive-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('Dismiss', document, transferId, delegationId , openedFromNodeId)" @click="Complete()" v-tooltip="$t('res_Label_Complete')"><v-icon>mdi-archive-outline</v-icon></v-btn>
                                    <v-btn class="dgs-new-button-icon" v-if="utils.ActionsPermission('SendCC', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('SendCC')" v-tooltip="$t('res_ButtonText_SendCC')"><v-icon>mdi-share-outline</v-icon></v-btn>

                                    <v-btn class="dgs-new-button-icon" @click="openVisualTracking()" v-if="utils.ActionsPermission('VisualTracking' , document, transferId, delegationId , openedFromNodeId)" v-tooltip="$t('res_Label_Tracking')">
                                        <img class="rtl-flip" src="/assets/images/icons/tracking.svg" />
                                    </v-btn>
                                    <div class="mr-1 ml-1 WorkflowActionsDiv"> 
                                        <v-btn class="StartflowBtn ma-1 StartBtn"  v-if="utils.ActionsPermission('Workflow-Complete', document, transferId, delegationId , openedFromNodeId,false)" @click="CompleteWorkflow(document,transferId)" ><v-icon style="color:white !important">mdi mdi-check-circle-outline</v-icon>{{ $t('res_Label_Complete') }}</v-btn>  
                                        <v-btn class="StartflowBtn ma-1 StartBtn"  v-if="utils.ActionsPermission('Workflow-Start', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'AdvanceWorkflow')" ><v-icon style="color:white !important">mdi mdi-sitemap-outline</v-icon>{{ $t('res_Label_StartWorkflow') }}</v-btn> 
                                        <v-btn class="AdvanceflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Advance', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'AdvanceWorkflow')" ><v-icon style="color:white !important">mdi mdi-arrow-up-thin</v-icon>{{ $t('res_ButtonText_Advance') }} </v-btn>
                                        <v-btn class="RejectflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Reject', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'RejectWorkflow')"><v-icon style="color:white !important">mdi mdi-close-circle-outline</v-icon> {{ $t('res_ButtonText_Reject') }} </v-btn>
                                        <v-btn class="SignflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Sign', document, transferId, delegationId , openedFromNodeId,false)" @click="signDocument" ><v-icon style="color:white !important">mdi-account-edit-outline</v-icon>{{ $t('res_ButtonText_Sign') }}</v-btn>  
                                        <v-btn class="light-blue ma-1 WorkflowAction" v-if="utils.ActionsPermission('Workflow-Transfer', document, transferId, delegationId , openedFromNodeId,false)" @click="OpenTransferForm('Forward',utils.getWorkflowId(document))"><v-icon style="color:white !important">mdi-share-outline</v-icon> {{ $t('res_Label_Transfer') }}</v-btn> 
                                        <v-btn class="VotingflowBtn ma-1 WorkflowAction" @click="openVoteFormDialog"  v-if="showVoteButton && transferId != 0 && utils.ActionsPermission('Workflow-Vote', document, transferId, delegationId , openedFromNodeId,false)"><v-icon style="color:white !important">mdi mdi-vote</v-icon> {{ $t('res_MeetingForm_Vote') }} </v-btn> 
                                        <v-btn class="VotingflowBtn ma-1 WorkflowAction" @click="openSeeVoteFormDialog"  v-if=" transferId != 0 && utils.ActionsPermission('Workflow-VotingResults', document, transferId, delegationId , openedFromNodeId,false)"><v-icon style="color:white !important">mdi mdi-ballot-outline</v-icon> {{ $t('res_Label_VotingResults') }} </v-btn>
                                    </div>  
                                </div>
                                <!--Buttons Mode-->
                                <div style="padding-left: 5px; padding-right: 5px;" class="d-flex gap-2 ml-auto" v-else>
                                    <v-btn class="light-success" v-if="utils.ActionsPermission('ResetDocument', document, transferId, delegationId , openedFromNodeId)"
                                           @click="resetDocument" v-tooltip="$t('res_Tooltip_ResetDocument')">
                                        <v-icon style="color: #009639;">mdi-backup-restore</v-icon>
                                    </v-btn>
                                    <v-btn class="light-success" v-if="utils.ActionsPermission('ForceGenerateReferenceNumber', document, transferId, delegationId , openedFromNodeId, document.canSign)"
                                           @click="forceGenerateReferenceNumber" v-tooltip="$t('res_Tooltip_GenerateReferenceNumber')">
                                        <v-icon style="color: #009639;">mdi-weather-lightning</v-icon>
                                    </v-btn>
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('PublishToMultiDocument', document, transferId, delegationId , openedFromNodeId)" @click="PublishToMultiDocument" v-tooltip="$t('res_ButtonText_PublishToMultiDocument')">
                                        <v-icon>mdi-publish</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_PublishToMultiDocument") }}
                                    </v-btn>
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('Preview', document, transferId, delegationId , openedFromNodeId) && this.document.categoryId!==1" @click="previewSignature" v-tooltip="$t('res_ButtonText_Review')">
                                        <v-icon>mdi-eye-refresh-outline</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Review") }}
                                    </v-btn>
                                    <v-btn class="light-success" v-if="utils.ActionsPermission('Sign', document, transferId, nodeDelegationId , openedFromNodeId, document.canSign,0,isContainedInSignerList)" @click="signDocument" v-tooltip="$t('res_ButtonText_Sign')">
                                        <v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Sign") }}
                                    </v-btn>
                                    <v-btn class="light-success" v-if="utils.ActionsPermission('Approve', document, transferId, delegationId , openedFromNodeId)" @click="ApproveDocument" v-tooltip="$t('res_ButtonText_Approve')">
                                        <v-icon style="color: #009639;">mdi-account-edit-outline</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Approve") }}
                                    </v-btn>
                                    <!-- hide sign and send until uae pass is implemented  -->
                                    <v-btn class="light-success" v-if="utils.ActionsPermission('SignAndSend', document, transferId, delegationId , openedFromNodeId, document.canSign,0,isContainedInSignerList)" @click="OpenTransferForm('Sign')" v-tooltip="$t('res_ButtonText_SignAndSend')">
                                        <v-icon style="color: #009639;">mdi-signature-freehand</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_SignAndSend") }}
                                    </v-btn>  
                                   
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('CreateOutgoing', document, transferId, delegationId , openedFromNodeId)" @click="CreateReplyLetter" v-tooltip="$t('res_ButtonText_Outgoing')">
                                        <v-icon>mdi-reply</v-icon>&nbsp;
                                        {{ $t("res_ButtonText_Outgoing") }}
                                    </v-btn>
                                   
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('Forward', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Forward')" v-tooltip="$t('res_ButtonText_Forward')">
                                        <v-icon>mdi-share-outline</v-icon>
                                        {{ $t('res_ButtonText_Forward') }}
                                    </v-btn>
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('ForwardCc', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('ForwardCc')" v-tooltip="$t('res_ButtonText_ForwardCC')">
                                        <v-icon>mdi-share-outline</v-icon>
                                        {{ $t('res_ButtonText_ForwardCC') }}
                                    </v-btn>
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('Endorse', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Endorse')" v-tooltip="$t('res_ButtonText_Endorse')">
                                        <v-icon>mdi-email-plus-outline</v-icon>
                                        {{ $t('res_ButtonText_Endorse') }}
                                    </v-btn>
                               
                                    <v-btn class="light-blue" v-if="!isArchived && utils.ActionsPermission('Archive', document, transferId, delegationId , openedFromNodeId)" @click="openCompleteDocumentDialog()" v-tooltip="$t('res_ButtonText_Archive')">
                                        <v-icon>mdi-archive-outline</v-icon>
                                        {{ $t('res_ButtonText_Archive') }}
                                    </v-btn>
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('Dismiss', document, transferId, delegationId , openedFromNodeId)" @click="Complete()" v-tooltip="$t('res_Label_Complete')">
                                        <v-icon>mdi-check-circle-outline</v-icon>
                                        {{ $t('res_Label_Complete') }}
                                    </v-btn>
                                    
                                    <!-- <v-btn v-if="showVoteButton && transferId != 0" @click="openVoteFormDialog" style="margin-left:5px;margin-right:5px" class="light-blue more-btn">
                                        <span>Vote</span>
                                    </v-btn>
                                    <v-btn @click="openSeeVoteFormDialog" v-if="transferId != 0" style="margin-left:5px;margin-right:10px" class="light-blue more-btn">
                                        <span>See Votes</span>
                                    </v-btn> -->

                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('Recall', document,transferId, delegationId , openedFromNodeId)" @click="recall()">{{ $t("res_MenuItems_Recall") }}</v-btn>
                                    <v-btn class="light-blue" @click="notifyEmailCorrespondence(true,false)" v-if="utils.ActionsPermission('NotifyEmail', document,transferId, delegationId , openedFromNodeId)">{{ $t("res_MenuItems_NotifyEmail") }}</v-btn>
                                    <div class="mr-1 ml-1 WorkflowActionsDiv">
                                        <v-btn class="StartflowBtn ma-1 StartBtn"  v-if="utils.ActionsPermission('Workflow-Complete', document, transferId, delegationId , openedFromNodeId,false)" @click="CompleteWorkflow(document,transferId)" ><v-icon style="color:white !important">mdi mdi-check-circle-outline</v-icon>{{ $t('res_Label_Complete') }}</v-btn>   
                                        <v-btn class="StartflowBtn ma-1 StartBtn"  v-if="utils.ActionsPermission('Workflow-Start', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'AdvanceWorkflow')" ><v-icon style="color:white !important">mdi mdi-sitemap-outline</v-icon>{{ $t('res_Label_StartWorkflow') }}</v-btn> 
                                        <v-btn class="AdvanceflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Advance', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'AdvanceWorkflow')" ><v-icon style="color:white !important">mdi mdi-arrow-up-thin</v-icon>{{ $t('res_ButtonText_Advance') }} </v-btn>
                                        <v-btn class="RejectflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Reject', document, transferId, delegationId , openedFromNodeId,false)" @click="AdvanceRejectWorkflow(document,transferId,'RejectWorkflow')"><v-icon style="color:white !important">mdi mdi-close-circle-outline</v-icon> {{ $t('res_ButtonText_Reject') }} </v-btn>
                                        <v-btn class="SignflowBtn ma-1 WorkflowAction"  v-if="utils.ActionsPermission('Workflow-Sign', document, transferId, delegationId , openedFromNodeId,false)" @click="signDocument" ><v-icon style="color:white !important">mdi-account-edit-outline</v-icon>{{ $t('res_ButtonText_Sign') }}</v-btn>  
                                        <v-btn class="light-blue ma-1 WorkflowAction" v-if="utils.ActionsPermission('Workflow-Transfer', document, transferId, delegationId , openedFromNodeId,false)" @click="OpenTransferForm('Forward',utils.getWorkflowId(document))"><v-icon style="color:white !important">mdi-share-outline</v-icon> {{ $t('res_Label_Transfer') }}</v-btn> 
                                        <v-btn class="VotingflowBtn ma-1 WorkflowAction" @click="openVoteFormDialog"  v-if="showVoteButton && transferId != 0 && utils.ActionsPermission('Workflow-Vote', document, transferId, delegationId , openedFromNodeId,false)"><v-icon style="color:white !important">mdi mdi-vote</v-icon> {{ $t('res_MeetingForm_Vote') }} </v-btn> 
                                        <v-btn class="VotingflowBtn ma-1 WorkflowAction" @click="openSeeVoteFormDialog"  v-if=" transferId != 0 && utils.ActionsPermission('Workflow-VotingResults', document, transferId, delegationId , openedFromNodeId,false)"><v-icon style="color:white !important">mdi mdi-ballot-outline</v-icon> {{ $t('res_Label_VotingResults') }} </v-btn>
                                    </div> 
                                    <!--
                                    <v-btn class="light-blue" v-if="utils.ActionsPermission('OpenWorkflowTransferForm', document, transferId, delegationId , openedFromNodeId)" @click="OpenWorkflowTransferForm()">
                                            OpenWorkflowTransferForm
                                        </v-btn>

                                        <v-btn class="light-blue" @click="openVisualTracking()" v-if="utils.ActionsPermission('VisualTracking' , document, transferId, delegationId , openedFromNodeId)" v-tooltip="$t('res_Label_Tracking')">
                                            <img class="rtl-flip" src="/assets/images/icons/tracking.svg" />
                                            {{ $t('res_Label_Tracking') }}
                                    </v-btn>
                                    -->
                                </div>
                                <!--More Actions Section-->
                                <v-menu content-class="viewer-button align-bottom-left" top offset-y :close-on-content-click="true" :left="$vuetify.rtl" :right="!$vuetify.rtl">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" class="light-blue more-btn">
                                            <span>{{ $t("res_MenuItems_MoreActions") }}</span>
                                        </v-btn>
                                    </template>

                                    <v-list class="actions_menu333">
                                        <v-menu content-class="viewer-button align-bottom-left2" :left="isLanguageEn" :right="!isLanguageEn" top offset-y>
                                            <template v-slot:activator="{ on, attrs }" v-if="nodeId != 1">
                                                <v-list-item v-bind="attrs" v-on="on" class="justify-content-between" v-if="showDispatchInfoComponent && utils.ActionsPermission('DispatchCorrespondence', document, transferId, delegationId , openedFromNodeId)">
                                                    {{ $t("res_DialogTitle_DispatchCorrespondence") }}
                                                    <v-icon>mdi-chevron-down</v-icon>
                                                </v-list-item>
                                            </template>
                                            <v-list>
                                                <v-list-item v-if="showDispatchInfoComponent" @click="dispatchCorrespondenceByEmail(false)">{{ $t("res_DialogTitle_DispatchCorrespondenceViaEmail") }}</v-list-item>
                                                <v-list-item v-if="showDispatchInfoComponent" @click="dispatchCorrespondence(true)">{{ $t("res_DialogTitle_DispatchCorrespondenceViaWeb") }}</v-list-item>
                                            </v-list>
                                        </v-menu>

                                        <v-list-item v-if="utils.ActionsPermission('SendCC', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('SendCC')" v-tooltip="$t('res_ButtonText_SendCC')">                                  
                                        {{ $t('res_ButtonText_SendCC') }}
                                        </v-list-item>

                                        <v-list-item  v-if="utils.ActionsPermission('Reject', document, transferId, delegationId , openedFromNodeId, document.canSign)" @click="OpenTransferForm('Rejected')" v-tooltip="$t('res_ButtonText_Reject')">                                       
                                        {{ $t("res_ButtonText_Reject") }}
                                        </v-list-item>

                                        <v-list-item v-if="utils.ActionsPermission('SendBack', document, transferId, delegationId , openedFromNodeId)" @click="OpenTransferForm('Send Back')" v-tooltip="$t('res_ButtonText_SendBack')">                                   
                                        {{ $t('res_ButtonText_SendBack') }}</v-list-item>
                                       

                                        <v-list-item @click="openVisualTracking()" v-if="utils.ActionsPermission('VisualTracking', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_Label_Tracking") }}</v-list-item>
                                        <v-list-item @click="openSigningHistory()" v-if="utils.ActionsPermission('SigningHistory', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_Label_SigningHistory") }}</v-list-item>
                                        <v-list-item @click="openDeliveryNote(document)" v-if="utils.ActionsPermission('GenerateDeliveryNote', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_Label_GenerateDeliveryNote") }}</v-list-item>
                                        <v-list-item @click="resetDocument()" v-if="utils.ActionsPermission('ResetDocument', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_Tooltip_ResetDocument") }}</v-list-item>
                                        <v-list-item @click="hideCorrespondenceDialog = true" v-if="utils.ActionsPermission('HideCorrespondence', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_Label_Hide") }}</v-list-item>
                                        <v-list-item @click="printCorrespondence(false)">{{ $t("res_ButtonText_Download") }}</v-list-item>
                                        <v-list-item @click="printCorrespondence(true)">{{ $t("res_ButtonText_PrintWithAttachments") }}</v-list-item>
                                        <v-list-item @click="reminderEmailDialog = true" v-if="utils.ActionsPermission('EmailReminder', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_ButtonText_Reminder") }}</v-list-item>
                                        <v-list-item @click="createCopyFromLetter">{{ $t('res_Label_CreateCopy') }}</v-list-item>
                                        <v-list-item @click="cancelFollowup()" v-if="utils.ActionsPermission('CancelFollowup', document, transferId, delegationId , openedFromNodeId)">{{ $t("res_ButtonText_CancelFollow_Up") }}</v-list-item>
                                        <v-list-item @click="notifyEmailCorrespondence(true,true)" v-if="utils.ActionsPermission('TaskReminder',document, transferId, delegationId, openedFromNodeId) && this.document.categoryId==6">{{ $t("res_ButtonText_RemindOnTask") }}</v-list-item>
                                        <v-menu content-class="align-bottom-left1" :left="isLanguageEn" :right="!isLanguageEn" top offset-x offset-y v-if="nodeId != 1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">
                                                    {{ $t("res_MenuItems_SendBy") }}
                                                    <v-icon>mdi-chevron-down</v-icon>
                                                </v-list-item>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="sendCorrespondence(false)">{{ $t("res_MenuItems_Email") }}</v-list-item>
                                                <v-list-item @click="sendCorrespondence(true)"> {{  $t("res_MenuItems_EmailWithAttachments") }}</v-list-item>
                                            </v-list>
                                        </v-menu>

                                    </v-list>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <v-dialog v-model="voteFormDialog" :persistent="true" style="overflow:none" width="450" height="750">
                <v-card>
                    <v-card-title>
                       {{ $t('res_MeetingForm_Vote')}}
                    </v-card-title>
                    <div>
                        <Vote :selectedLang="selectedLang" :workflowId="selectedWorkflowId"  :dialogModelShow="voteFormDialog" :transferId="transferId" :documentId="documentId" @closeVoteFormDialog="closeVoteFormDialog" @submitVoting="submitVoting"/>
                    </div>
                </v-card>
            </v-dialog>  

            <v-dialog v-model="openScanDialog" content-class="dialog fullscreen-dialog bg-white" fullscreen>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">{{ $t('ResourceScanFile') }}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="openScanDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <ScanFile  :documentId="documentId" @GetImageData="uploadScan"  ></ScanFile>
                </v-card>
            </v-dialog>

            <v-dialog v-model="seeVoteFormDialog" :persistent="true" content-class="smaller-dialog" width="450" height="750">
                <v-card>
                    <v-card-title>
                     {{ $t('res_Label_VotingResults')}}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SeeVote :selectedLang="selectedLang" :dialogModelShow="seeVoteFormDialog" :documentId="documentId"
                        @closeSeeVoteFormDialog="closeSeeVoteFormDialog" />
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog persistent v-model="previewSignatureDialog" content-class="preview-signature-dialog fullscreen-dialog dialog with-fixed-actions bg-white" width="100%" fullscreen>
                <div class="dialog-header">
                    <v-toolbar class="bg-white">
                        <div class="custom-icon-wrapper">
                            <v-icon @click="previewSignatureDialog=false">custom-icon left-arrow-icon</v-icon>
                        </div>
                        <h1 class="mb-0">
                            {{ $t("res_CardHeaders_PreviewSignature") }}
                        </h1>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="previewSignatureDialog=false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body">
                    <preview-signature :documentId="documentId" @closeDialog="closeReviewSignatureDialog" />
                </div>
            </v-dialog>

            <v-dialog v-model="notifyEmailDialogCorrespondence"
                      content-class="choose-template-dialog fullscreen-dialog dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                         <v-card-title class="p-0">
                            {{this.isMOM ? $t("res_ButtonText_RemindOnTask"): $t("res_MenuItems_SendBy")  }}  
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="notifyEmailDialogCorrespondence=false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                      <notify-email id="notifyEmailCorrespondence" v-on:closeDialog="notifyEmailDialogCorrespondence = false"
                                  :toEmail="toEmail" :emailCC="emailCC" :subject="notifySubject" :documentId="documentId" :transferId="transferId" :isMOM ="this.isMOM " ></notify-email>
                </v-card>
            </v-dialog>
            <v-dialog v-model="reminderEmailDialog" content-class="small-dialog" width="400px">
                <v-card>
                    <v-card-title class="p-0">
                        {{ $t("res_ButtonText_Reminder") }}
                    </v-card-title>
                    <div class="card-body">
                        <div class="col-sm-12">
                            <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                            <v-menu content-class="p-0" v-model="remindToDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="reminderToDate" label="" readonly v-bind="attrs" v-on="on" solo
                                        append-icon="mdi-calendar">
                                        <template v-slot:append>
                                            <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="reminderToDate" @input="remindToDateMenu = false"
                                    :min="nowDate"></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="reminderEmailDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="ReminderByEmail()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
 
            <v-dialog v-model="transferFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ transferFormHeader }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="transferFormDialog=false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>

                    <TransferForm :documentId="documentId" :disableRecipient="recipientDisabled" :disableAdvancedTransfer="disableAdvancedTransfer" :sign="signForm"
                                  :purpose="purpose" :transferId="transferId" :transferCC="transferCC"
                                  :transferFormDialog="transferFormDialog" :delegationId="delegationId" :rejected="rejected"
                                  :successMessage="transferSuccessMessage" :transferTo="(userDefaultTransferTo == null ? transferTo : userDefaultTransferTo)"
                                  :transferToMulti="transferToMulti" :transferFormType="transferFormType"
                                  :checkForAttachmentsUploadMultiApproval="checkForAttachmentsUploadMultiApproval"
                                  :hideTransferCC="hideTransferCC" :readOnlyPurpose="readOnlyPurpose" :hasBeenSignedWithUAEPass="document.hasBeenSignedWithUAEPass"
                                  :defaultDueDate="document.dueDate" @closeTransformDialog="closeTransferFormDialog"
                                  @cancelCorrespondenceDocument="transferFormDialog = false" :workflowId="workflowIdForTransfer"
                                  :forwardCC="forwardCc" :documentCreatedByUserId="document.createdByUserId" :categoryId="document.categoryId"
                                  :isUAEPassEnabled="isUAEPassEnabled" :isDocusignEnabled="isDocusignEnabled" :documentByFile="documentByFile"
                                  :mom_purpose_items="mom_purpose_items" :canBeSignedByExternalUser="this.getCanBeSignedByExternalUser()"
                                   />
                </v-card>
            </v-dialog>

            <v-dialog v-model="workflowTransferFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">Workflow Transfer Form</v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="workflowTransferFormDialog = false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>

                    <WorkflowTransferForm :documentId="documentId" :disableRecipient="recipientDisabled" :sign="signForm"
                                  :purpose="purpose" :transferId="transferId" :transferCC="transferCC"
                                  :transferFormDialog="transferFormDialog" :delegationId="delegationId" :rejected="rejected"
                                  :successMessage="transferSuccessMessage" :transferTo="transferTo"
                                  :transferToMulti="transferToMulti"
                                  :checkForAttachmentsUploadMultiApproval="checkForAttachmentsUploadMultiApproval"
                                  :defaultDueDate="document.dueDate" @closeTransformDialog="closeTransferFormDialog"
                                  @cancelCorrespondenceDocument="workflowTransferFormDialog = false" />
                </v-card>
            </v-dialog>
            

            <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title>
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <Sign :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                              @refreshAfterClosingSignDialog="refreshAfterClosingSignDialog"
							  :isSignAndSend="false"
                              @closeSignFormDialog="closeSignFormDialog" />
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                                              @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                                              @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                                              @closeSignFormDialog="closeSignFormDialog"
											  :isSignAndSend="false" :hasBeenSignedWithUAEPass="document.hasBeenSignedWithUAEPass"
                                              :isUAEPassEnabledForTemplate="selectedTemplate ? selectedTemplate.isUAEPassEnabled : (selectedTemplate == null)"
                                              :isEsealEnabledForTemplate="selectedTemplate?selectedTemplate.isEsealEnabled:false"
                                              @refreshAfterClosingSignMethodSelect="refreshAfterClosingSignMethodSelect" />
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="signingHistoryDialog" content-class="dialog with-fixed-actions bg-white  justify-content-center w-50" fullscreen scrollable>
                <v-card class="bg-white">
                    <v-toolbar class="bg-white">
                        <v-card-title>
                            {{ $t("res_CardHeaders_SigningHistory") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="signingHistoryDialog = false">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                    <v-card-text class="border-top p-0 d-flex">
                        <SigningHistory :documentId="documentId" :dialogModelShow="signingHistoryDialog"></SigningHistory>
                    </v-card-text>

                    <!-- signing history button -->
                    <v-card-actions class="d-flex justify-content-end" style="background-color:  #E7EBEF;">
                        <v-btn class="dgs-new-button-inner" style="height: 48px" @click="openVisualTracking()"
                               v-if="this.document.showVisualTracking">
                            <img class="rtl-flip" src="/assets/images/icons/tracking.svg" />{{ $t('res_Label_Tracking') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div v-if="signingHistoryDialog" class="overlay"></div>

            <v-dialog v-model="visualTrackingDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
                      width="100%" fullscreen>
                <div class="dialog-header">
                    <div class="custom-icon-wrapper tracker-close">
                        <v-icon @click="visualTrackingDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </div>
                <div class="dialog-body h-100">
                    <iframe id="trackingFrame" :src="trackingFrameSrc"
                            style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
                </div>
            </v-dialog>

            <v-dialog persistent v-model="linkedDocumentDialog"
                      content-class="linked-document-dialog fullscreen-dialog dialog with-fixed-actions bg-white" width="100%" fullscreen>
                <div class="dialog-header">
                    <v-toolbar class="bg-white">
                        <div class="custom-icon-wrapper">
                            <v-icon @click="linkedDocumentDialog=false">custom-icon left-arrow-icon</v-icon>
                        </div>
                        <h1 class="mb-0">{{ $t("res_CardHeaders_SelectLinkedMail") }}</h1>
                        <v-spacer></v-spacer>
                        <div class="custom-icon-wrapper">
                            <v-icon @click="closeSelectLinkedDocumentPopup">custom-icon mdi-close</v-icon>
                        </div>
                    </v-toolbar>
                </div>
                <div class="dialog-body">
                    <LinkedDocument ref="linkedDocument" :documentId="documentId" @closeSelectLinkedDocumentPopup="closeSelectLinkedDocumentPopup" :dialogModelShow="linkedDocumentDialog"></LinkedDocument>
                </div>
            </v-dialog>

            <!-- attach + persistent: avoid nested fullscreen dialog clicks/focus closing the parent letter dialog (back to inbox) -->
            <v-dialog v-model="correspondenceDialog" persistent attach content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen
                      @keydown.esc="closeCorrespondenceDialog">
                <CreateDocumentView :documentId="linkedDocumentId" :transferId="linkedTransferId" :dialogCount="Number(dialogCount) + linkedCorrespondenceDepth"
                                    viewMode="readonly" :delegationId="linkedDelegationId" :closeDialogEvent="closeCorrespondenceDialog" 
                                    :key="createDocumentViewComponentKey" :viewingLinkedDocument="true"
                                    />
            </v-dialog>

            <v-dialog v-model="LinkedEmailDeleteDialog" content-class="small-dialog" width="600" height="250">
                <v-card>
                    <v-card-title>
                        {{ $t("res_DialogTitle_DeleteLinkedEmail") }}
                    </v-card-title>
                    <div class="card-body">
                        <label class="mt-2">
                            {{ $t("res_Msgs_DeleteLinkedEmailConfirmation") }}
                        </label>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="light-blue" @click="cancelLinkedEmailDeleteDialog">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn class="primary" @click="deleteLinkedDocument">{{ $t("res_ButtonText_Delete") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="completeDocumentDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ $t("res_DialogTitle_CompleteNotes") }}
                    </v-card-title>
                    <div class="card-body">
                        <label>{{ $t("res_Msgs_EnterNotes") }} *</label>
                        <v-textarea v-model="completeDocument_noteText" solo></v-textarea>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn class="dgs-new-button" @click="completeDocument_noteText = ''; completeDocumentDialog = false;">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="completeDocument">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="addFavoriteDialog" content-class="profile-dialog system-notifiction m-0" width="400px">
                <v-card class="p-2 card-scroll">
                    <div class="min-height-58px">
                        <v-text-field class="bg-gray" label="" v-model="favoriteName" :placeholder="$t('res_Label_Name')">
                        </v-text-field>
                        <v-btn color="primary" @click="addFavoriteDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn class="m-2" color="primary" @click="addFavoriteDocument">{{ $t("res_Label_AddToFavorite") }}</v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="removeFavoriteDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ $t("res_Label_Alert") }}
                    </v-card-title>
                    <div class="card-body">
                        <h3>{{ $t("res_Msgs_EnsureRemoveFavorite") }}</h3>

                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="removeFavoriteDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="removeFavorite">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dispatchCorrespondenceFormDialog" width="500" height="400" >
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ $t("res_DialogTitle_DispatchCorrespondence") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="dispatchCorrespondenceFormDialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <DispatchCorrespondence :documentId="documentId" :dialogModelShow="dispatchCorrespondenceFormDialog"
                        v-on:closeDialog="dispatchCorrespondenceFormDialog = false"></DispatchCorrespondence>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dispatchFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_DialogHeaders_DispatchLetter") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="dispatchFormDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <DispatchLetter :documentId="documentId" :dialogModelShow="dispatchFormDialog" :documentSubject="document.subject"
                    :withAttachments="withAttachments" v-on:closeDialog="dispatchFormDialog = false"></DispatchLetter>
            </v-card>
        </v-dialog>

            <v-dialog v-model="dispatchCorrespondenceByEmailDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">
                            {{ $t("res_DialogHeaders_DispatchLetter") }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="dispatchCorrespondenceByEmailDialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <DispatchLetter :documentId="documentId" :dialogModelShow="dispatchCorrespondenceByEmailDialog" withAttachments="true"
                        v-on:closeDialog="dispatchCorrespondenceByEmailDialog = false"></DispatchLetter>
                </v-card>
            </v-dialog>

            <v-dialog v-model="deliveryNoteDialog" content-class="small-dialog" width="650" height="1350">
                <v-card>
                    <v-card-title>{{ $t('res_Label_DeliveryNote') }}</v-card-title>
                    <div style="overflow: hidden">
                            <DeliveryNoteConfiguration :documentId="documentId" :referenceNumber="referenceNumber" :deliveryNoteDialog="deliveryNoteDialog" @closeDeliveryNote="deliveryNoteDialog = false"/>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="hideCorrespondenceDialog" content-class="small-dialog" width="400px">
                <v-card>
                    <v-card-title>
                        {{ $t("res_Label_Hide") }}
                    </v-card-title>
                    <div class="card-body">
                        <div class="col-sm-12">
                            <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                            <v-menu content-class="p-0" v-model="hideToDateMenu" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="hideToDate" label="" readonly v-bind="attrs" v-on="on"
                                                    solo append-icon="mdi-calendar">
                                        <template v-slot:append>
                                            <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="hideToDate" @input="hideToDateMenu = false"
                                                :min="nowDate"></v-date-picker>
                            </v-menu>
                        </div>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="hideCorrespondenceDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" @click="SaveForLater">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>



             <v-dialog fullscreen content-class="fullscreen-dialog" v-model="visualTrackingDialogNew">  
                <TrackingView2 :documentId="visualTrackingDialogNew_selectedDocumentId" :closeDialogFunc="closeNewTrackerDialog" />  
             </v-dialog> 

        </div>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants.js'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import Attachments from '@/components/Attachments.vue'
    import Notes from '@/components/Notes.vue'
    import TransferList from '@/components/TransferList.vue'
    import PreviewSignature from '@/components/PreviewSignature.vue'
    import TransferForm from '@/components/TransferForm.vue'
    import WorkflowTransferForm from '@/components/TransferFormWorkflow.vue'
    import VueWysiwyg from '@mycure/vue-wysiwyg'
    import SigningHistory from '@/components/SigningHistory.vue'
    import TrackingTree from '@/components/TrackingTree.vue'
    import Sign from '@/components/Sign.vue'
    import LinkedDocument from '@/components/LinkedDocuments.vue'
    import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import UserInfo from '@/components/UserInfo.vue'
    import NotifyEmail from '@/components/NotifyEmail.vue'
    import debounce from "lodash.debounce"
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import { Container, Draggable } from 'vue-smooth-dnd'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
    import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
    import RecipientSenderSelector from '@/components/RecipientSenderSelector.vue'
    import DocumentSelector from '@/components/DocumentSelector.vue'
    import DispatchCorrespondence from '@/components/DispatchCorrespondence.vue'
    import DispatchLetter from '@/components/DispatchLetter.vue'
    import DispatchInfo from '@/components/DispatchInfo.vue'
    import DeliveryNoteConfiguration from '@/components/DeliveryNoteConfiguration.vue'
    import FilingClassificationPlanSelector from '@/components/FilingClassificationPlanSelector.vue'
    import Vote from '@/components/Vote.vue'
    import SeeVote from '@/components/SeeVote.vue'

    import DynamicFormRender from '@/components/DynamicFormRender.vue';
    import FormBuilderUtil from '@/utils/formBuilderHelper';
    import TrackingView2 from "@/views/TrackingView2.vue"; 
    import ScanFile from '@/components/ScanFile.vue';
    import { mapGetters } from 'vuex'


    var baseUrl = constants.baseApiUrl;

    export default {
        name: 'CreateDocumentView',
        components: {
            TrackingView2,
            MultiSelect, Container, Draggable, Attachments, Notes, TransferList, PreviewSignature, VueWysiwyg,
            TransferForm, SigningHistory, TrackingTree, Sign, LinkedDocument, NotifyEmail, CreateDocumentView, UserInfo,
            StructureUserSelector, TransferNotesIcon, SignSelectSignMethod, RecipientSenderSelector, DocumentSelector, DispatchCorrespondence,
            DispatchLetter, DispatchInfo, FilingClassificationPlanSelector, DeliveryNoteConfiguration, DynamicFormRender, WorkflowTransferForm,Vote,SeeVote,ScanFile
        },
        props: {
            dialogOpenClose: { type: Boolean },
            documentId: { type: Number, default: 0 },
            dialogCount: { type: Number, default: 1 },
            transferId: { type: Number, default: 0 },
            delegationId: { type: Number, default: 0 },
            viewMode: { type: String, default: 'readonly' },
            openedFromNodeId: { type: Number, default: 0 },
            openerPage: { type: String, default: '' },
            closeDialogEvent: { type: Function, default: function () { } },
            createReplyDocumentEvent: { type: Function, default: function() { } },
            toEmail: '',
            emailCC: '',
            isArchived: { type: Boolean,default:false },
            nodeDelegationId: { type: Number, default: 0 },
            viewingLinkedDocument: { type: Boolean, default: false }
        },
        data() {
            return {
                disabled: false, 
                hideTransferCC:false,
                readOnlyPurpose: false,
                forwardCc:false,
                multiDocument: false,
                PrintingOptionsMultiplelbl: this.$t('res_Label_PrintingOptionsMultiple'),
                PrintingOptionsSinglelbl: this.$t('res_Label_PrintingOptionsSingle'),
                emailLabel: '',
                showNLA_Email: false,
                showNLA_Fax: false,
                viewOutgoingAddedFields: false,
                viewIncomingAddedFields: false,
                classificationPlanIdRequired: true,
                selectedLang: 'en', 
                formattedReceivedDate: '',
                messageType_items: [],
                document_receivedDate_menu: false,
                workflowIdForTransfer: 0,
				selectedWorkflowId: 0,
                showVoteButton:true,
                voteFormDialog:false,
                seeVoteFormDialog:false,
                visualTrackingDialogNew: false,
                visualTrackingDialogNew_selectedDocumentId: 0,
                viewingLinkedDocument: false,
                rejected: false,
                transferSuccessMessage: '',
                recipientDisabled: false,
	            transferFormType: '',
                formattedDate: '',
                formattedDueDate: '',
                notifySubject: '',
                DownloadOptions:false,
                isLanguageEn: true,
                notifyEmailDialogCorrespondence: false,
                LinkedEmailDeleteDialog: false,
                loading: false,
                correspondenceDialog: false,
                /** Stack depth for linked-mail modals only (do not mutate dialogCount prop). */
                linkedCorrespondenceDepth: 0,
                createDocumentViewComponentKey: 0,
                count: 0,
                counter: 0,
                nowDate: new Date().toISOString().slice(0, 10),
                user_structures: [],
                user_structure: {},
                cc_items: [],
                priority_items: [],
                privacy_items: [],
                workflow_items: [],
                importance_items: [],
                Committee_items:[],
                document_date_menu: false,
                document_due_date_menu: false,
                TranslatedSubjectLabel: '',
                KeywordsLabel: '',
                OtherAttachmentsLabel: '',
                reminderEmailDialog: false,
                hideToDateMenu: false,
                reminderToDate: '',
                fromEmail: [],
                remindToDateMenu: false,
                dispatchFormDialog: false,
                withAttachments: false,
				isMOM: false,
                mom_purpose_items:[],
                selectedDocumentId: 0,
				documentType_items: [],					   
                document: {
                    categoryId: 0,
                    cc: [],
                    send_after_sign: [],
                    Guests:[],
                    priority: {},
                    privacy: {},
                    importance: {},
                    Committee:{},
                    externalReferenceNumber: '',
                    date: '',
                    subject: '',
                    dueDate: '',
                    translatedSubject: '',
                    keywords: '',
                    otherAttachments: '',
                    signers: [],
                    formData: {},
                    purposeId: 0,
                    secretForward: false,
                    purposeIdBeforeRevoke: 0,
                    workflow: {},
                    // for ADFD
                    country: '',
                    // for NLA
                    email: '',
                    fax: '',
                    deliveryTypes:'',
                    project: '',
                    projectNumber: '',
                    showProjectGroup: false,
                    isNeedReply: null,
                    replyDocument: {},
                    StructureForm: null,
                    TemplateForm: null,
                    tags: [{ id: -1, name: ''}],
                    //for Incoming Document
                    receivedDate:'',
                    messageType: 0, 
					documentType: {},
                    documentTypeId: null
                   
                },
                subject: '',
                signersList: [],

                signerSelectionEnabled: true,
                selectedTemplate: null,

                showCCBlock: false,
                showTranslatedSubjectBlock: false,
                showKeywordsBlock: false,
                showOtherAttachmentsBlock: false,

                barcodeFormDialog: false,
                barcodeImage: '',

                empty_viewer: true,
                viewerFrameSrc: '',

                canSignDocument: false,
                previewSignatureDialog: false,
                documentSignersBackup: '',

                transfer: {},
                documentInfo: {},

                transferCC: [{}],
                userDefaultTransferTo: null,
                transferTo: {},
                transferToMulti: [],
                transferFormHeader: window.translate("res_Label_Transfer"),
                transferFormDialog: false,
                workflowTransferFormDialog: false,
                signFormDialog: false,
                propertyBag: {},
                purpose: {},
                purposeId: 0,
                signForm: false,
                checkForAttachmentsUploadMultiApproval: false,
                disableAdvancedTransfer:true,
                isSecretNote:false,
                toUserId: 0,
                loginUserId:0,
                loginUserStuctureId:0,
                isContainedInSignerList:null,

                trackingFrameSrc: '',
                signingHistoryDialog: false,
                visualTrackingDialog: false,
                linkedDocumentDialog: false,
                linkedDocuments: [],
                linkedDocumentsFullList: [],
                defaultNumberOfLinkedDocumentsToDisplay: 3,
                numberOfLinkedDocumentsToDisplay: 3,

                linkedDocumentId: '',
                linkedTransferId: '',
                linkedDelegationId: '',

                completeDocumentDialog: false,
                completeDocument_noteText: '',
                isImportanceFieldVisible: true,
                utils: utils,
                debouncedHandlerSigner: null,
                constants: constants,
                selectSignMethodFormDialog: false,
                dispatchCorrespondenceFormDialog: false,
                dispatchCorrespondenceByEmailDialog: false,
                showDispatchInfoComponent: false,
                // for ADFD
                countriesList: [],
                projectsList: [],
                projectsNumbersList: [],

                //for NLA
                deliveryTypesList: [],

                //FavoriteDocument
                addFavoriteDialog: false,
                removeFavoriteDialog: false,
                favoriteName:'',
                isFavorite: false,
                showReplyDocumentSection: false,
                nodeId: 0,
                tagOptions:[],
                deliveryNoteDialog: false,
                referenceNumber: "",
                hideCorrespondenceDialog: false,
                hideToDate: '',
                hideToDateMenu: false,
                filingClassificationPlanMode: {
                    FilingPlanMode: 1,
                    ClassificationPlanMode: 2,
                    BothPlanModes: 3
                },
                attachmentId: 0,
                showWorkflowFeature: window.showWorkflowFeature,

                // dynamic forms settings
                dynamicFormByStructureIdAndCategoryId: 'dynamicFormByStructureIdAndCategoryId',
                dynamicFormByTemplateId:'dynamicFormByTemplateId',
                dynamicFormDetails: [],
                filterByStructureIdAndCategoryId: {} = { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: 0, url: baseUrl, isEditable:0},
                filterByTemplateId: {} = { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: 0, url: baseUrl, isEditable: 0 },
                collectDynamicFormsData : {documentId: 0,jsonValuesByTemplate: '',  jsonValuesByStructure: ''},
                openScanDialog : false,
                showDWTLicenseMessage: false,
                isMenuOpen: false,
                PrintOption: false,
                council_users_items: [],
                selectedItems: [],
                sortedUsers:[],
                Users_Headers: [
                    {
                        text: "",  // The header for the checkbox column
                        align: "center", // Align the checkbox column header
                        sortable: false, // Disable sorting for the checkbox column
                        value: "select", // Define a unique key for this column
                    },
                    {
                        text: this.$t("res_Label_Title"),
                        class: "text-center",
                        sortable: false,
                    },
                    {
                        text: this.$t("res_Label_TitleAr"),
                        class: "text-center",
                        sortable: false,
                    },
                    {
                        text: this.$t("res_CheckBox_IsHead"),
                        class: "text-center",
                        sortable: false,
                    },
                    {
                        text: this.$t("res_Label_Order"),
                        class: "text-center",
                        sortable: false,
                    },
                    {
                        text: this.$t("res_Label_Task"),
                        class: "text-center",
                        sortable: false,
                    },
                ],
                isUAEPassEnabled: false,
                isDocusignEnabled: false,
                documentByFile: false
            }
        }, 
        mounted() 
        { 
            this.selectedLang =  localStorage.getItem('lang');
            //to-remove  
            if(sessionStorage.getItem('user') != '' && sessionStorage.getItem('user') != null)
            {  
                const userId = JSON.parse(sessionStorage.getItem('user')).profile.Id;
                const userItem = window.usersSelectedStructureForTransfer.length == 0 ? null : window.usersSelectedStructureForTransfer.find(s=>s.userId == userId);
                if(userItem != null) 
                { 
                this.userDefaultTransferTo = {'id':  userItem.id , 'name' : (this.selectedLang == 'ar' ? userItem.nameAr : userItem.nameEn)};
                }
                else
                {
                    this.userDefaultTransferTo = null;
                }
            } 
            if (document.querySelectorAll('.v-application--is-rtl').length) 
                this.isLanguageEn = false

             if (enableWebTwain || enableWebTwain == undefined || enableWebTwain == null) 
            {       
                this.showDWTLicenseMessage = false;
            } 
            else { this.loadDWTLicenseMessage();}   

            this.TranslatedSubjectLabel = window.translate("res_Label_TranslatedSubject")
            this.KeywordsLabel = window.translate("res_Label_Keywords")
            this.OtherAttachmentsLabel = window.translate("res_Label_OtherAttachments")
            this.viewerFrameSrc = ''
            this.empty_viewer = true
            this.getUserStructures()
            this.getLookupItems()
            this.getDocumentWithTransfer();
            this.getLinkedDocuments();
            this.checkFavorite();
            // this.isTransferVoted();

            this.isImportanceFieldVisible = window.isImportanceFieldVisible;
            var user = JSON.parse(sessionStorage.getItem("user"));
            this.fromEmail = user.profile.Email
            this.loginUserId = user.profile.Id
            this.loginUserStuctureId=user.profile.StructureId
            this.showDispatchInfoComponent = window.showDispatchInfoComponent
        },
       computed: {
           ...mapGetters(['allTransferPurposes']),
            sortedCouncilUsers() {
                this.sortedCouncilUsers=[];
                this.sortedUsers = [];
                const selectedItems = this.council_users_items.filter(item => this.selectedItems.includes(item.id));
                const unselectedItems = this.council_users_items.filter(item => !this.selectedItems.includes(item.id));
                
                const sortedItems = [...selectedItems,...unselectedItems ];

                this.sortedUsers = sortedItems;
                return sortedItems;
            }
        },
        watch:
        {
           
            documentId() {
                this.viewerFrameSrc = ''
                this.getLinkedDocuments()
                this.getUserStructures()
                this.checkFavorite();
                if (this.documentId > 0 && this.transferId == 0) {
                    this.getDocumentWithTransfer();
                }
                else {
                    this.user_structure = {}
                    this.document = {
                        categoryId: 0,
                        cc: [{}],
                        send_after_sign: [],
                        Guests:[{}],
                        priority: {},
                        privacy: {},
                        importance: {},
                        Committee:{},
                        externalReferenceNumber: '',
                        date: '',
                        subject: '',
                        dueDate: '',
                        translatedSubject: '',
                        keywords: '',
                        otherAttachments: '',
                        signers: [],
                        formData: {},
                        purposeId: 0,
                        secretForward: false,
                        purposeIdBeforeRevoke: 0,
                        country: '',
                        deliveryTypes: '',
                        project: '',
                        projectNumber: '',
                        statusId: null,
                        isNeedReply: null,
                        replyDocument: null,
                        templateForm: null,
                        structureForm: null,
                        tags: [{ id: -1, name: ''}],
						documentType: {},
                        documentTypeId: null
                    }
                    this.subject = ''
                }
            },
            transferId() {
                if (this.transferId > 0)
                    this.getDocumentWithTransfer()
                else
                    this.transfer = {}
            },
            'document.date': function () {
                if (this.document.date != null && this.document.date != '' && this.document.date != undefined)
                    this.formattedDate = utils.dateFormat(this.document.date)
                else {
                    this.document.date = new Date().toISOString().slice(0, 10)
                    this.formattedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
            'document.dueDate': function () {
                this.formattedDueDate = utils.dateFormat(this.document.dueDate)
            }, 
            'document.deliveryTypes': function(){
                this.deliverytypes_Updated();
            },
            'document.receivedDate': function () {
                if (this.document.receivedDate != null && this.document.receivedDate != '' && this.document.receivedDate != undefined)
                    this.formattedReceivedDate = utils.dateFormat(this.document.receivedDate)
                else {
                    this.document.receivedDate = new Date().toISOString().slice(0, 10)
                    this.formattedReceivedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
        },
        methods:
        {  
            loadDWTLicenseMessage() {
                this.showDWTLicenseMessage = true;
            }, 
            getCanBeSignedByExternalUser() {
                try {
                    const form = JSON.parse(this.selectedTemplate?.form || '{}');
                    if (form && form.hasOwnProperty('canBeSignedByExternalUser')) {
                        return form.canBeSignedByExternalUser;
                    }
                    return false;
                } catch (e) {
                    return false; // fallback value
                }
            },
            isOutgoingByFile() {
                //return this.document.categoryId === constants.categories_Helper_Enum.Outgoing.value && this.documentByFile === true;
                //console.log("logging isoutgoing")
                //console.log(this.document.templateId);
                //console.log(this.document.templateId == null || this.document.templateId === "");
                return this.document.templateId == null || this.document.templateId === "";
            },
            moveToLast(item, index) {
                const isSelected = this.selectedItems.includes(item.id);
                if (!isSelected) {
                    this.selectedItems = this.selectedItems.filter(id => id !== item.id);
                    item.selected = false;
                } else {
                    this.selectedItems.push(item.id);
                    item.selected = true;
                }
            },
            performAction(action) 
            {
                if (action === 'Upload') 
                    this.$refs.attachmentCtrl.uploadAttachment()
                else if (action === 'Scan') 
                    this.openScanDialog = true

                this.isMenuOpen = false
            },
            printWithAttachmentWithStamps() 
            {
                utils.PrintFile(constants.baseApiUrl + 'ViewerActions/DownloadWithAnnotation?id=' + this.attachmentId, this.subject + '.pdf')
            },
            printwithoutsignture()
            {
                utils.PrintFile(constants.baseApiUrl + 'Document/Downloadwithoutheaderandsignture?documentId=' + this.documentId, this.document.subject + '.pdf')
            },
            printwithoutHeader()
            {
                utils.PrintFile(constants.baseApiUrl + 'Document/Downloadwithoutheaderandsignture?documentId=' + this.documentId+'&removeHeader=true', this.document.subject + '.pdf')
            },
            deliverytypes_Updated()
            {
                this.showNLA_Email = false;
                this.showNLA_Fax = false; 
                if(this.document.deliveryTypes.Id == constants.deliveryType_Enum.email) { this.showNLA_Email = true; }
                else if(this.document.deliveryTypes.Id == constants.deliveryType_Enum.fax) { this.showNLA_Fax = true; }
            },
            submitVoting(){
															   
                this.showVoteButton= false;
                this.closeVoteFormDialog();
										
            },
            closeVoteFormDialog(){
                this.voteFormDialog=false;
                this.isTransferVoted()
            },
            openVoteFormDialog(){
                this.voteFormDialog=true;
            },
            closeSeeVoteFormDialog(){
                this.seeVoteFormDialog=false;
            },
            openSeeVoteFormDialog()
            {
                this.seeVoteFormDialog=true;
            },
            closeNewTrackerDialog() 
            { 
				this.visualTrackingDialogNew = false;
		    }, 
            cancelFollowup() {
            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_FollowUpCancelConfirmation"),
                () => {
                    var methodUrl = "Followup/CancelFollowup?transferId=" + this.transferId
                    axios.post(constants.baseApiUrl + methodUrl, null, { headers: constants.headers })
                        .then(() => {
                            window.showAlert("res_Msgs_FollowUpCancellation", 'success')
                            this.closeDialog(false,false)
                        })
                        .catch(err => console.warn(err))
                },
                () => { })
        },
            ReminderByEmail() 
            {
                if (this.reminderToDate == '') {
                    window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                    return
                }
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Transfer/ReminderByEmail?transferId=' + this.transferId + '&toDate=' + this.reminderToDate + '&toEmails=' + this.fromEmail)
                    .then((res) => {
                        if (res.data == false) {
                            window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                        }
                        window.showAlert(this.$t('res_Msgs_Reminder'), 'success')
                        this.reminderEmailDialog = false;
                        this.reminderToDate = '';
                        this.hideToDateMenu = false;
                        this.closeDialog(false,false)
                    })
                    .catch((err) => { console.log(err); })
                    .finally(()=>{ window.hideLoading(); })
            },
            printCorrespondence(value)
            {
                this.withAttachments = value;
                var methodUrl = 'Document/Download?documentId=' + this.documentId
                if (this.withAttachments)
                    methodUrl = 'Document/DownloadWithAttachments?documentId=' + this.documentId

                utils.DownloadFile(constants.baseApiUrl + methodUrl, this.document.subject + '-' + this.document.referenceNumber + '.pdf')
            },
            sendCorrespondence(value) 
            {
                this.withAttachments = value;
                this.selectedDocumentId = this.documentId
                this.dispatchFormDialog = true
            },
            openMultiSelectCtrl(id) 
            {
                if (id === 1) this.$refs.multiselect1.activate()
                else if (id === 2) this.$refs.multiselect2.activate()
                else if (id === 3) this.$refs.multiselect3.activate()
                else if (id === 4) this.$refs.multiselect4.activate()
                else if (id === 5) this.$refs.multiselect5.activate()
                else if (id === 7) this.$refs.multiselect7.activate()
                // for adfd
                else if (id === 15) this.$refs.multiselect15.activate()
                else if (id === 16) this.$refs.multiselect16.activate()
                else if (id === 17) this.$refs.multiselect17.activate()
                else if (id === 18) this.$refs.multiselect18.activate()
                // for adha
                else if (id === 21) this.$refs.multiselect21.activate()
            },
            closeCorrespondenceDialog() {
                if (this.linkedCorrespondenceDepth > 0)
                    this.linkedCorrespondenceDepth--
                if (Number(this.dialogCount) === 1 && this.linkedCorrespondenceDepth === 0)
                    this.viewMode = 'edit'
                this.correspondenceDialog = false
                this.createDocumentViewComponentKey += 1;
                this.viewingLinkedDocument = false;
            },
            closeTransferFormDialog() {
                this.closeDialog(false, false);
            },
            CreateReplyLetter(){
                this.createReplyDocumentEvent(this.documentId)
            },
            closeDialog(isBack = false, checkForShowConfirmation = true) {
                function close(context, isBack) {
                    if (isBack)
                        context.closeDialogEvent(context.openerPage)
                    else
                        context.closeDialogEvent('')
                }

                var showConfirmation = false
                if (checkForShowConfirmation) {
                    if (this.viewMode == "edit")
                        showConfirmation = true
                }

                if (showConfirmation) {
                    window.showInformation(
                        window.translate("res_Msg_Close"),
                        isBack ? window.translate("res_Msgs_BackConfirmation") : window.translate("res_Msgs_CloseDocumentConfirmation"),
                        () => {
                            close(this, isBack);
                        },
                        () => { });
                }
                else
                    close(this, isBack)
            },
            fillSenderRecipientDesignatedPersonsData(obj) {
                if (obj != null) {
                    this.$set(this.document, 'sendingEntityId', obj.selectedSenderStructureId != null ? obj.selectedSenderStructureId : null);
                    this.$set(this.document, 'sendingDesignatedPersonId', obj.selectedSendingDesignatedPersonId != null ? obj.selectedSendingDesignatedPersonId : null);
                    this.$set(this.document, 'compoRecipientDesignatedPersons', obj.compoRecipientDesignatedPersons);                
                }
            },
            getUserStructures() 
            {
                axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
                    .then(response => 
                    {
                        this.user_structures = response.data;
                        if (this.user_structures.length > 0)
                            this.user_structure = this.user_structures[0]
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getLookupItems() 
            {
                this.priority_items = constants.priorities
                this.privacy_items = constants.privacies
                this.importance_items = constants.importancies 
                this.messageType_items = constants.messageTypes
                this.document.priority = this.priority_items[0]
                this.document.privacy = this.privacy_items[0]
                this.document.importance = this.importance_items[0]
                var isPowerUser=constants.isCompanyAdmin && !constants.isFullAdmin;
                axios
				.get(
					constants.baseApiUrl +
						//`Council/GetAllCouncils`
                        `Council/GetAllCouncils?isPowerUser=${isPowerUser}`
				)
				.then((res) => {
                    this.Committee_items =  res.data.records
				})
				.catch((err) => console.warn(err));

                if (constants.showDocumentType)
                {
                    this.documentType_items = constants.documentTypes
                    this.document.documentType = this.documentType_items[0]
                }
            },
            getTemplateDescription(templateId, signersList) 
            { 
                this.selectedTemplate = null
                window.documentView.template_signatureCount = 0
                window.documentView.template_signersList = []
                utils.defaultGet('Template/GetTemplateDescription?Id=' + templateId, (res) => {
                    if (res.data != null && res.data != undefined) {
                        this.selectedTemplate = res.data
                            constants.isUAEPassEnabledTemplate = this.selectedTemplate.isUAEPassEnabled;
                            constants.isEsealEnabledTemplate = this.selectedTemplate.isEsealEnabled ;

                        // for adfd
                        if (constants.client_version_Id == 'ADFD') {
                            if (this.selectedTemplate.form != null && this.selectedTemplate.form != undefined && this.selectedTemplate.form != '') {
                                var templateJson = JSON.parse(this.selectedTemplate.form);
                                this.showProjectGroup = templateJson.showProjectGroup
                            }
                            else
                                this.showProjectGroup = false
                        }

                        window.documentView.template_isWorkflow = this.selectedTemplate.isWorkflow

                        if ((this.document.categoryId == 3 && this.selectedTemplate.isWorkflow == true) || (constants.client_version_Id == "DDA")) {
                            if (signersList == null || signersList == undefined || signersList.length == 0) {
                                // check if you have predefined signers
                                var predefinedSigners = this.selectedTemplate.signatoryList
                                if (predefinedSigners != null && predefinedSigners != undefined && predefinedSigners != '') {
                                    var signatoryUserIds = ''
                                    var signatoryList = predefinedSigners.split('|').filter(e => e);
                                    for (var i = 0; i < signatoryList.length; i++) {
                                        signatoryUserIds += "'" + signatoryList[i].split('#')[0] + "',"
                                    }

                                    // remove last comma if exists
                                    if (signatoryUserIds.endsWith(','))
                                        signatoryUserIds = signatoryUserIds.substring(0, signatoryUserIds.length - 1)

                                    utils.defaultGet('StructureUser/GetUsersForMultiSelect?userIds=' + signatoryUserIds, (res) => {
                                        if (res != undefined && res.data != null && res.data != undefined) {
                                            this.document.signers = res.data
                                            if (res.data.length == this.selectedTemplate.signatureCount)
                                                this.signerSelectionEnabled = false
                                            else {
                                                var predefinedSignersCount = res.data.length
                                                for (var i = 0; i < this.selectedTemplate.signatureCount - predefinedSignersCount; i++)
                                                    this.document.signers.push({ index: res.data.length + i + 1 })
                                            }
                                            window.documentView.template_signersList = this.document.signers
                                        }
                                    }, this.handleError, true);
                                }
                                else {
                                    for (var i = 0; i < this.selectedTemplate.signatureCount; i++)
                                        this.document.signers.push({ index: i + 1 })

                                    this.signerSelectionEnabled = true
                                }
                            }
                            else {
                                this.document.signers = signersList
                                window.documentView.template_signersList = signersList

                                this.signerSelectionEnabled = true
                                if (this.splitAndRemoveEmpty(this.selectedTemplate.signatoryList, '|').length == signersList.length)
                                    this.signerSelectionEnabled = false
                            }
                        }

                        window.documentView.template_signatureCount = this.selectedTemplate.signatureCount
                    }
                },
                    this.handleError, true);
            },
            splitAndRemoveEmpty(input, delimiter) {
                if (input == null) {
                    return [];
                }
                const filteredParts = input.split(delimiter).filter(part => part.trim() !== '');
                return filteredParts;
            },
            handleError(error) {
                this.loading = false
                console.log(error)
                window.showAlert('res_Msgs_ErrorOccured', 'error')
            },
            setViewerUrl(attachmentId) 
            {
                this.attachmentId = attachmentId;
                if (attachmentId != 0) 
                {
                    var transferId = this.transferId == 0 ? '' : this.transferId
                    this.empty_viewer = false

                    var viewerMode = ''
                    if (this.viewMode == 'viewMode' || this.viewMode == 'readonly')
                        viewerMode = '&pageMode=view'

                    if(this.viewingLinkedDocument)
                        this.openedFromNodeId = -1

                    window.setViewerData(attachmentId, this.documentId, null, this.document.subject + '-' + this.document.referenceNumber);
                    this.viewerFrameSrc = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '' + viewerMode + '&r=' + new Date().getTime()
                }
                else {
                    this.empty_viewer = true
                    this.viewerFrameSrc = ''
                }
            },
            refreshViewer() {
                if (this.viewerFrameSrc != '') {
                    this.empty_viewer = false
                    this.viewerFrameSrc = this.viewerFrameSrc + '&refresh=' + Math.random()
                }
            },
            documentCCSelectedChange(items) {
                this.$set(this.document, 'cc', this.handleFirstElement(items));
            },
            documentSendAfterSignSelectedChange(items) {
                this.$set(this.document, 'send_after_sign', this.handleFirstElement(items));

            },
            replyDocumentSelectedChange(item) {
                this.$set(this.document, 'replyDocument', item);
            },

            handleFirstElement(data, tempItem) {
                if (data.length > 0) {
                    var shouldAddTemp = true;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].isTemp
                            || data[i].id == undefined
                            || data[i].id == null) {
                            shouldAddTemp = false;
                            break;
                        }
                    }
                    if (shouldAddTemp) {
                        if (tempItem == undefined || tempItem == null) {
                            tempItem = { isTemp: true, name: 'temp' };
                        }
                        data = [tempItem, ...data];
                    } else if (data.length == 1) {
                        data = [];
                    }
                }
                return data;
            },
            documentSigneeSelectedChange(item, index) {        
                this.$set(this.document.signers, index, item);
            },
            addNewSignee() {
                this.document.signers.push({});
                window.documentView.template_signatureCount = this.document.signers.length;
            },
            deleteSignee(indexToRemove)
            {
                this.document.signers.splice(indexToRemove, 1);
            },
            priorityChanged(item) {
                let today = new Date(); // create a new Date object with today's date
                let daysLater1 = new Date(today.getTime() + 15 * 24 * 60 * 60 * 1000); // add 15 days to the current date
                let daysLater2 = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days to the current date
                let daysLater3 = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000); // add 2 days to the current date
                if (this.document.date == '' || this.document.date == null || this.document.date == undefined) {
                    this.document.date = new Date().toISOString().slice(0, 10);
                }
                if (item.id == 1)
                    this.document.dueDate = daysLater1.toISOString().slice(0, 10)
                else if (item.id == 2)
                    this.document.dueDate = daysLater2.toISOString().slice(0, 10)
                else if (item.id == 3)
                    this.document.dueDate = daysLater3.toISOString().slice(0, 10)
            },
            fillDocumentDataForEdit(item) 
            {

                this.document.categoryId = item.categoryId
                this.document.referenceNumber = item.referenceNumber
                this.document.createdDate = item.createdDate
                this.document.canSign = item.canSign
                this.document.secretForward = item.SecretForward
                this.document.statusId = item.statusId

                if (item.carbonCopies != null && item.carbonCopies != undefined && item.carbonCopies.length > 0) 
                {
                    var carbonCopyObjects = JSON.parse(item.carbonCopies)

                    var ccItems = []
                    carbonCopyObjects.forEach(function (cc) {
                        ccItems.push({ id: cc.id, name: cc.text, isUser: (carbonCopyObjects[0].id.lastIndexOf('-') != -1) })
                    });

                    if (ccItems.length > 0)
                        this.document.cc = [{}, ...ccItems]
                    else
                        this.document.cc = ccItems
                }
                if (item.committeeGuests != null && item.committeeGuests != undefined && item.committeeGuests.length > 0) 
                {
                    var committeeGuestsObjects = JSON.parse(item.committeeGuests)

                    var committeeGuestItems = []
                    committeeGuestsObjects.forEach(function (customGuest) {
                        committeeGuestItems.push({ id: customGuest.id, name: customGuest.text })
                    });

                    if (committeeGuestItems.length > 0)
                        this.document.Guests = [{}, ...committeeGuestItems]
                    else
                        this.document.Guests = committeeGuestItems
                }

              	  if( this.messageType_items != null && this.messageType_items.length > 0)
                {  
                    if (typeof(item.messageType) != 'undefined' && item.messageType != null)
                            this.document.messageType = this.messageType_items.find(x => x.Id == item.messageType)
                        else
                            this.document.messageType = this.messageType_items[0]  
                } 

                if (item.priorityId != null)
                    this.document.priority = this.priority_items.find(x => x.id == item.priorityId)
                else 
                {
                    this.document.priority = this.priority_items[0]
                    this.priorityChanged(this.document.priority)
                }

                if (item.privacyId != null)
                    this.document.privacy = this.privacy_items.find(x => x.id == item.privacyId)
                else
                    this.document.privacy = this.privacy_items[0]

                if (item.importanceId != null)
                    this.document.importance = this.importance_items.find(x => x.id == item.importanceId)
                else
                    this.document.importance = this.importance_items[0]
                if (item.committee != null){
                    this.document.Committee = this.Committee_items.find(x => x.id == item.committee)
			        this.council_users_items= this.document.Committee.councilMembers;
                }else{
                    this.council_users_items=[];
                }
               if(item.documentCommitteeMembers!= null){

                    var documentCommitteeMembersObjects = JSON.parse(item.documentCommitteeMembers)
                    var councilUsers= this.council_users_items;
                    var selected=[];
                    documentCommitteeMembersObjects.forEach(function (documentCommitteeMember) {
                        var selectedUser=councilUsers.filter(item =>""+item.userId+"-"+item.structureId+"" ==documentCommitteeMember.id )
                        
                        const user = selectedUser[0];
                        user.Task = documentCommitteeMember.Task!='null'?documentCommitteeMember.Task:'';

                        if(documentCommitteeMember.text){
                            selected.push(user.id)
                        }
                    });
                    this.selectedItems=selected;
                    councilUsers.forEach(user => {
                        user.selected = selected.includes(user.id);  
                    });
                }      

                if (constants.showDocumentType)  
                 {                 
                    if (item.documentTypeId != null)
                        this.document.documentType = this.documentType_items.find(x => x.id == item.documentTypeId)
                    else                 
                        this.document.documentType = this.documentType_items[0]    
                }

                if (item.externalReferenceNumber != null)
                    this.document.externalReferenceNumber = item.externalReferenceNumber

                if (item.dueDate != null && item.dueDate != undefined)
                    this.document.dueDate = item.dueDate

                if (item.subject != null) 
                {
                    this.document.subject = item.subject
                    this.subject = item.subject
                }
               

                var selectedUserStructure = this.user_structures.find(s => s.structureId == item.createdByStructureId)
                if (selectedUserStructure != null)
                    this.user_structure = selectedUserStructure

                var formDataObj = JSON.parse(item.formData);
                this.document.formData = item.formData;

                if (formDataObj != null) 
                {
                    if (this.viewIncomingAddedFields && typeof(formDataObj.receivedDate) != 'undefined' && formDataObj.receivedDate != '')
                    {
                        this.document.receivedDate = formDataObj.receivedDate
                    }  

                    if (this.viewIncomingAddedFields && typeof(formDataObj.messageTypeId) != 'undefined' && formDataObj.messageTypeId != '')
                    {
                        this.document.messageType = this.messageType_items.find(s=>s.Id == formDataObj.messageTypeId); 
                    }    
                    
                    if (typeof(formDataObj.multiDocument) != 'undefined')
                    {
                        if(formDataObj.multiDocument == true) {this.multiDocument = '1';}
                        else {this.multiDocument = '0';} 
                    }     

                    if (typeof(formDataObj.documentDate) != 'undefined' && formDataObj.documentDate != '') 
                    {
                        this.document.date = formDataObj.documentDate
                    }

                    this.document.translatedSubject = formDataObj.translatedSubject
                    if (formDataObj.translatedSubject != '')
                        this.showTranslatedSubjectBlock = true

                    this.document.keywords = formDataObj.keywords
                    if (formDataObj.keywords != '')
                        this.showKeywordsBlock = true

                    this.document.otherAttachments = formDataObj.otherAttachments
                    if (formDataObj.otherAttachments != '')
                        this.showOtherAttachmentsBlock = true

                    this.documentSignersBackup = formDataObj.signers
                    if (!utils.CheckIfNullOrEmpty(formDataObj.sendAfterSign))
                    this.document.send_after_sign = formDataObj.sendAfterSign

                    // if (formDataObj && formDataObj.templateId != '')
                    //     this.getTemplateDescription(formDataObj.templateId, JSON.parse(formDataObj.signers))

                    if (formDataObj.workflowId != null && formDataObj.workflowId != undefined) 
                    {
                        var workflowItem = this.workflow_items.find(x => x.id == formDataObj.workflowId)
                        if (workflowItem != null && workflowItem != undefined)
                            this.document.workflow = workflowItem
                    }

                    // for ADFD
                    if (formDataObj.country != null && formDataObj.country != undefined) 
                    {
                        var country = constants.countriesList.find(x => x.Id == formDataObj.country)
                        if (country != null && country != undefined)
                            this.document.country = country
                    }

                    // for NLA
                    if (formDataObj.deliveryTypes != null && formDataObj.deliveryTypes != undefined && formDataObj.deliveryTypes != '') 
                    {
                        var deliverytypes = constants.deliveryTypesList.find(x => x.Id == formDataObj.deliveryTypes)
                        console.log('in the function ',deliverytypes)
                        if (deliverytypes != null && deliverytypes != undefined)
                            this.document.deliveryTypes = deliverytypes
                    
                            this.deliverytypes_Updated();

                            if (typeof(formDataObj.email) != 'undefined' && formDataObj.email != '')
                            {
                                this.document.email = formDataObj.email; 
                            }   

                            if (typeof(formDataObj.fax) != 'undefined' && formDataObj.fax != '')
                            {
                                this.document.fax = formDataObj.fax; 
                            }   
                    }
                    if (formDataObj.project != null && formDataObj.project != undefined && formDataObj.project != '') 
                    {
                        var project = constants.projectsList.find(x => x.Id == formDataObj.project)
                        if (project != null && project != undefined)
                            this.document.project = project
                    }
                    if (formDataObj.projectNumber != null && formDataObj.projectNumber != undefined && formDataObj.projectNumber != '') 
                    {
                        var projectNumber = constants.projectsNumbersList.find(x => x.Id == formDataObj.projectNumber)
                        if (projectNumber != null && projectNumber != undefined)
                            this.document.projectNumber = projectNumber
                    }
                }

                if (item.attachmentId != null)
                    this.setViewerUrl(item.attachmentId)
               
                this.document.canSign = item.canSign
                this.document.isRegistered = item.isRegistered
                this.document.cCed = item.cCed

                if (this.document.cc && this.document.cc.length > 1)
                    this.showCCBlock = true;

                
                axios.get(constants.baseApiUrl + 'Template/GetTemplateSigners?documentId='+
                this.documentId, { headers: constants.headers })
                    .then(res => 
                    {
                        if(res.data != null)
                        {
                            
                            var signersCount=res.data.filter(f=> f.signatureDate!=null).length;
                            if(signersCount>0){
                               this.disabled=true;
                            }
                        }
                    })
                    .catch(err => console.warn(err))   
             

                window.documentView.document = this.document                         
            },
            getDocumentWithTransfer() 
            {
                axios.get(constants.baseApiUrl + 'Transfer/GetDocumentTransferInfo?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.nodeDelegationId)
                    .then(response => 
                    {console.log('doc = ', response.data)
                     
                          if( response.data[0].transferId != null){
                         this.transferId= response.data[0].transferId
                         }
                        this.document = utils.copyObject(response.data[0], this.document)  
                        this.classificationPlanIdRequired = this.document.categoryId != constants.categories_Helper_Enum.Incoming.value; 
                        this.viewIncomingAddedFields = this.document.categoryId == constants.categories_Helper_Enum.Incoming.value; 
                        this.viewOutgoingAddedFields = this.document.categoryId == constants.categories_Helper_Enum.Outgoing.value && constants.viewMultiDocumentOption; 
                        sessionStorage.setItem("documentIsSigned", this.document.isSigned);
                        this.document.tags = [{ id: -1, name: ''}]
                        this.selectedWorkflowId = this.document.workflowId; 
                       
                        if (response.data[0].tags != null)
                        {
                            var assignedTags = JSON.parse(response.data[0].tags);
                            for (var i = 0; i < assignedTags.length; i++)
                            {
                                this.document.tags.push(assignedTags[i]);
                            }
                        }

                      
                        if (response.data[0].categoryId==6&&response.data[0].committeeGuests != null && response.data[0].committeeGuests != undefined && response.data[0].committeeGuests != '' &&response.data[0].committeeGuests.length > 0) 
                        {  
                            var committeeGuestsObjects = JSON.parse(response.data[0].committeeGuests)

                            var committeeGuestItems = []
                            committeeGuestsObjects.forEach(function (customGuest) {
                                committeeGuestItems.push({ id: customGuest.id, name: customGuest.text })
                            });

                            if (committeeGuestItems.length > 0)
                                this.document.Guests = [{}, ...committeeGuestItems]
                            else
                                this.document.Guests = committeeGuestItems;
                                
                        }

                       
                        if (response.data[0].committee != null){
                            console.log (this.Committee_items);
                        this.document.Committee = this.Committee_items.find(x => x.id == response.data[0].committee)
                        this.council_users_items= this.document.Committee.councilMembers;
                        }
                        else{
                            this.council_users_items=[];
                        }
                        if(response.data[0].documentCommitteeMembers!= null){

                            var documentCommitteeMembersObjects = JSON.parse(response.data[0].documentCommitteeMembers)
                            var councilUsers= this.council_users_items;
                            var selected=[];
                            documentCommitteeMembersObjects.forEach(function (documentCommitteeMember) {
                                var selectedUser=councilUsers.filter(item =>""+item.userId+"-"+item.structureId+"" ==documentCommitteeMember.id )
                                
                                const user = selectedUser[0];
                                user.Task = documentCommitteeMember.Task!='null'?documentCommitteeMember.Task:'';

                                if(documentCommitteeMember.text){
                                    selected.push(user.id)
                                }
                            });
                            this.selectedItems=selected;
                            councilUsers.forEach(user => {
                                user.selected = selected.includes(user.id);  
                            });
                        }      


                        
                        console.log("hiiiiiiiiiiiiiiiiii")

                        this.subject = this.document.subject
                       
                        let documentForm = JSON.parse(this.document.formData);  

                        if(documentForm != null)
                        { 
                            if (documentForm.deliveryTypes != null && documentForm.deliveryTypes != undefined && documentForm.deliveryTypes != '') 
                            {
                                var deliverytypes = constants.deliveryTypesList.find(x => x.Id == documentForm.deliveryTypes)
                                console.log('in the function2 ',deliverytypes)
                                if (deliverytypes != null && deliverytypes != undefined)
                                    this.document.deliveryTypes = deliverytypes
                            }
                            if (documentForm && documentForm.signers && documentForm.signers != null) 
                            {    
                                this.documentSignersBackup = JSON.stringify(JSON.parse(this.document.formData).signers)
                                this.document.signers = JSON.parse(JSON.parse(this.document.formData).signers);
                                if(constants.enableConfigrationSignature== true)
                                {
                                    var signerss= this.document.signers;
                                    var logedinuser_structure=this.loginUserId+"-"+this.loginUserStuctureId;
                                    const exists = signerss.some(obj => obj.id === logedinuser_structure);
                                    
                                    if(this.document.signers.length ==0|| this.document.signers[0].id==null){
                                        this.isContainedInSignerList=true;
                                    }
                                    if(exists){
                                        this.isContainedInSignerList=true;
                                    }
                                    if(this.document.signers[0].id!=null &&!exists)
                                    {
                                        this.isContainedInSignerList=false;

                                    }
                                 }
                  
                            }
                            if (typeof(documentForm.documentDate) != 'undefined' && documentForm.documentDate != '') 
                            {
                                this.document.date = documentForm.documentDate
                            }

                        }

                        if(constants.enableConfigrationSignature== true)
                        {
                        if (response.data[0] != null && response.data[0].canSign != undefined)
                            this.document.canSign = JSON.parse(response.data[0].canSign)
                        else
                            this.document.canSign = null;
                        }

                        if (response.data[0] != null && response.data[0].sendingEntityId != undefined)
                            this.document.sendingEntityId = JSON.parse(response.data[0].sendingEntityId)
                        else
                            this.document.sendingEntityId = null;

                        if (response.data[0] != null && response.data[0].sendingDesignatedPersonId != undefined)
                            this.document.sendingDesignatedPersonId = JSON.parse(response.data[0].sendingDesignatedPersonId)
                        else
                            this.document.sendingDesignatedPersonId = null;

                        if (response.data[0] != null && response.data[0].receiversAndDesignatedPersons != undefined)
                            this.document.receiversAndDesignatedPersons = JSON.parse(response.data[0].receiversAndDesignatedPersons)

                        if (response.data[0] != null && (response.data[0].isNeedReply == true || response.data[0].isNeedReply == false))
                            this.document.isNeedReply = response.data[0].isNeedReply;

                        if (response.data[0] != null && response.data[0].replyDocument != undefined) {
                            
                            let replyDoc = JSON.parse(response.data[0].replyDocument);
                            if (replyDoc.replyDocument != undefined && replyDoc.replyDocument != null && Object.keys(replyDoc.replyDocument).length !== 0)
                            {
                                this.document.replyDocument = JSON.parse(replyDoc.replyDocument);
                                this.document.replyDocument.formattedLabel = this.document.replyDocument.subject + " - " + this.document.replyDocument.ReferenceNumber
                                this.showReplyDocumentSection = true;
                            }
                            else
                                this.showReplyDocumentSection = false;
                        }
                        else
                            this.showReplyDocumentSection = false;


                        if (response.data[0] != null && response.data[0].filingPlan != undefined) {
                            this.document.filingPlan = JSON.parse(response.data[0].filingPlan)
                        }
                        else
                            this.document.filingPlan = null;

                        if (response.data[0] != null && response.data[0].classificationPlan != undefined) {
                            this.document.classificationPlan = JSON.parse(response.data[0].classificationPlan)
                        }
                        else
                            this.document.classificationPlan = null;

                        if (response.data[0] != null && response.data[0].structureForm != undefined) {
                            this.document.structureForm =  response.data[0].structureForm
                        }
                        else
                            this.document.structureForm = null;

                        if (response.data[0] != null && response.data[0].templateForm != undefined) {
                            this.document.templateForm = response.data[0].templateForm
                        }
                        else
                            this.document.templateForm = null;

                        window.documentView.document = this.document
                        if (this.viewMode == 'edit_new') 
                        {
                            axios.post(constants.baseApiUrl + 'Transfer/MarkTransferAsRead?transferId=' + this.transferId + '&delegationId=' + this.delegationId, null)
                                .then(response => { console.log('MarkedTransferAsRead') })
                                .catch(error => console.log(error));
                        }

                        var formDataObj = JSON.parse(response.data[0].formData);
                        if (formDataObj && formDataObj.templateId != '')
                            this.getTemplateDescription(formDataObj.templateId, JSON.parse(formDataObj.signers))
                        else
                            this.documentByFile = true

                        if (this.canEditDocumentMetaData())
                            this.fillDocumentDataForEdit(response.data[0]);

                        this.fillRequiredDataForDynamicForms(response.data[0]);
                       
                        var context = this
                        var showTransferNote = (this.document.openedDate == null ? true : false)
                        setTimeout(() => {
                            if (context.$refs.transferNotesIcon)
                                context.$refs.transferNotesIcon.setTransferNotes(this.document.fromUserId, this.document.instruction, showTransferNote)
                        }, 50);

                        if (this.showWorkflowFeature)
                        {
                            // documentForm.templateId
                            axios.get(constants.baseApiUrl + 'Workflow/GetAvailableWorkflows?categoryId=' + this.document.categoryId + '&templateId=0')
					        .then(response => { 
                            this.workflow_items = response.data; 
                            this.document.workflow = this.selectedWorkflowId > 0 
                            ? this.workflow_items.find(s => s.id == this.selectedWorkflowId) 
                            : null;})
                                .catch(error => console.log(error))
                                .finally(() => this.loading = false);
                        }
                        this.disableAdvancedTransfer = !this.document.isSigned;
                        this.isSecretNote = this.document.isSecretNote;            
                        this.toUserId = this.document.toUserId;       
                    })
                    .catch(error => console.log(error))
            },
            fillRequiredDataForDynamicForms(item)
            {
                var formDataObj = JSON.parse(item.formData);
                if (item != null && item.structureForm != undefined) {
                    this.document.structureForm = item.structureForm
                }
                else
                    this.document.structureForm = null;

                if (item != null && item.templateForm != undefined) {
                    this.document.templateForm = item.templateForm
                }
                else
                    this.document.templateForm = null;

                this.filterByStructureIdAndCategoryId.structureId = this.document.createdByStructureId;
                this.filterByStructureIdAndCategoryId.categoryId = this.document.categoryId;
                this.filterByStructureIdAndCategoryId.isEditable = this.canEditDocumentMetaData();
                this.filterByTemplateId.templateId = formDataObj ? formDataObj.templateId : null;
                this.filterByTemplateId.isEditable = this.canEditDocumentMetaData();

                setTimeout(()=> 
                {
                    if (this.$refs.formStructureAndCategory != undefined)
                        this.$refs.formStructureAndCategory.generateHtmlForForm();
                    if (this.$refs.formTemplate != undefined)
                        this.$refs.formTemplate.generateHtmlForForm();
                }, 100);
            },
            prepareFormDataObject(isRegister) 
            {
                var templateId = '';

                if (this.document.formData != undefined) 
                {
                    var formDataObj = JSON.parse(this.document.formData);
                    if (formDataObj != null && formDataObj.templateId != undefined)
                        templateId = formDataObj.templateId;
                }

                if (this.document.signers != null && this.document.signers != undefined && this.document.signers.length > 0)
                    this.document.signers.forEach((item) => {
                        item.index = this.document.signers.indexOf(item) + 1
                    });

                var workflowId = '';
                if (this.showWorkflowFeature)
                    if (this.document.workflow != undefined && this.document.workflow != null && this.document.workflow.id != undefined && this.document.workflow.id != null)
                        workflowId = this.document.workflow.id;
                console.log('delivery types saving',this.document.deliveryTypes)
                var model = new FormData();
                model.append('id', this.documentId);
                model.append('categoryId', this.document.categoryId);
                model.append('subject', this.document.subject);
                model.append('formData', JSON.stringify({
                    "translatedSubject": this.document.translatedSubject,
                    "keywords": this.document.keywords,
                    "otherAttachments": this.document.otherAttachments,
                    "templateId": templateId,
                    "signers": JSON.stringify(this.document.signers),
                    "documentDate": this.document.date,
                    "country": (this.document.country == null || this.document.country == "") ? '' : this.document.country.Id,
                    "deliveryTypes": (this.document.deliveryTypes == null || this.document.deliveryTypes == "") ? '' : this.document.deliveryTypes.Id,
                    "fax": ((this.document.deliveryTypes != null && this.document.deliveryTypes != "") && this.document.deliveryTypes.Id == constants.deliveryType_Enum.fax) ? this.document.fax : '',
                    "email": ((this.document.deliveryTypes != null && this.document.deliveryTypes != "") && this.document.deliveryTypes.Id == constants.deliveryType_Enum.email) ? this.document.email : '',
                    "project": (this.document.project == null || this.document.project == "") ? '' :this.document.project.Id,
                    "projectNumber":(this.document.projectNumber == null || this.document.projectNumber == "") ? '' : this.document.projectNumber.Id,
                    "sendAfterSign": this.document.send_after_sign,
                    "workflowId": workflowId,
                    "receivedDate": this.document.receivedDate,
                    "messageTypeId": (this.document.messageType == null || this.document.messageType == "") ? '' : this.document.messageType.Id,
                    //"email": this.document.deliveryTypes != null && this.document.deliveryTypes.Id > 0 && this.document.deliveryTypes.Id == constants.deliveryType_Enum.email ? this.document.email : '' ,
                    //"fax": this.document.deliveryTypes != null && this.document.deliveryTypes.Id > 0 && this.document.deliveryTypes.Id == constants.deliveryType_Enum.fax ? this.document.fax : '' ,
                    "multiDocument": this.multiDocument == 1
                }));
                //};
                if (this.document.sendingEntityId != null)
                    model.append('sendingEntityId', this.document.sendingEntityId);

                if (this.document.sendingDesignatedPersonId != null)
                    model.append('sendingDesignatedPersonId', this.document.sendingDesignatedPersonId);

                model.append('compoRecipientDesignatedPersons', JSON.stringify(this.document.compoRecipientDesignatedPersons));
                
                this.document.tags = this.document.tags.filter(x=>x.id != -1);
                if (this.document.tags.length > 0)
                {
                    for(var i = 0; i< this.document.tags.length; i++)
                    {
                        var item = this.document.tags[i];
                        model.append(`tags[${i}][Id]`, item.id);
                        model.append(`tags[${i}][Name]`, item.name);
                    }
                }
                
               var DocumentCommitteeMembers=[];
                this.sortedUsers.forEach((councilData,index) => {
                    DocumentCommitteeMembers.push({
                                    id: 0,
                                    DocumentId:this.documentId,
                                    UserId:councilData.userId,
                                    ContactOrder:index + 1,
                                    Attend: councilData.selected ==true ? true: false,
                                    Task:councilData.Task != undefined  ? councilData.Task:null,
                                    StructureId:councilData.structureId
							     });
							});
                if (this.document.dueDate != null && this.document.dueDate != undefined && this.document.dueDate != '')
                    model.append('dueDate', this.document.dueDate);
                else
                    model.append('dueDate', '');

                model.append('priorityId', this.document.priority.id);
                model.append('privacyId', this.document.privacy.id);
                if (this.document.documentType != null && this.document.documentType.id != undefined)
                    model.append('documentTypeId', this.document.documentType.id)
                else
                    model.append('documentTypeId', '')
														  
                if (this.document.importance.id)
                    model.append('importanceId', this.document.importance.id);
                
                if (this.document.Committee.id)
                    model.append('Committee', this.document.Committee.id);   
             
               if (DocumentCommitteeMembers.length > 0)
                {
                    for(var i = 0; i< DocumentCommitteeMembers.length; i++)
                    {
                        var item = DocumentCommitteeMembers[i];
                        model.append(`DocumentCommitteeMembers[${i}][Id]`, item.id);
                        model.append(`DocumentCommitteeMembers[${i}][DocumentId]`, item.DocumentId);
                        model.append(`DocumentCommitteeMembers[${i}][UserId]`, item.UserId);
                        model.append(`DocumentCommitteeMembers[${i}][ContactOrder]`, item.ContactOrder);
                        model.append(`DocumentCommitteeMembers[${i}][Attend]`, item.Attend);
                        model.append(`DocumentCommitteeMembers[${i}][StructureId]`, item.StructureId);
                        model.append(`DocumentCommitteeMembers[${i}][Task]`, item.Task);
                    }
                }

                
                model.append('classificationId', '');
                if (this.document.cc != null && this.document.cc != undefined) 
                {
                    this.document.cc.forEach(element => {
                        if (element != null && element != undefined && element.id != null && element.id != undefined)
                            model.append('carbonCopy[]', element.id);
                    });
                }
            
                if (this.document.Guests != null && this.document.Guests != undefined) 
                {
                    this.document.Guests.forEach(element => {
                        if (element != null && element != undefined && element.id != null && element.id != undefined){
                            let idString =  element.id .toString();
                            model.append('CommitteeGuest[]', idString.includes("-")? idString.split("-", 2)[0] : idString);

                        }
                    });
                }
                model.append('register', isRegister);
                model.append('createdByStructureId', this.user_structure.structureId);
                model.append('externalReferenceNumber', this.document.externalReferenceNumber);
                model.append('transferId', '');
                
                if(this.document.isNeedReply != null)
                    model.append('isNeedReply', this.document.isNeedReply);

                if (this.document.replyDocument != null && this.document.replyDocument != undefined && this.document.replyDocument.id != null && this.document.replyDocument.id != undefined) {
                    model.append('replyDocumentId', this.document.replyDocument.id);
                }
                else
                    model.append('replyDocumentId', 0);

                if (this.document.filingPlanId != null)
                    model.append('filingPlanId', this.document.filingPlanId);
                    
                if (this.document.classificationPlanId != null)
                    model.append('classificationPlanId', this.document.classificationPlanId);

                return model
            },
            saveDocument() 
            {
                var model = this.prepareFormDataObject(false)
                this.log_form_data(model)

                axios.post(constants.baseApiUrl + 'Document/Save', model, { headers: constants.headers })
                    .then(res => {
                        window.showAlert('res_Msgs_ChangesSavedSuccess', 'success')
                        this.getDocumentWithTransfer()
                    })
                    .catch(error => console.log(error))
            },
            log_form_data(formData) 
            {
                for (var pair of formData.entries())
                    console.log(pair[0] + ': ' + pair[1]);
            },
            isFormValid() 
            {
                var retVal = true
                if(constants.client_version_Id == 'NLA' && (constants.mandatoryDeliveryType && this.document.categoryId != 1 && (this.document.deliveryTypes =='' || this.document.deliveryTypes ==null)))
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    retVal = false;
                }

                if (constants.client_version_Id == 'NLA' && this.showNLA_Email && (this.document.email == '' || this.document.email == null))
                {   
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    retVal = false;
                }

                if (this.user_structure == null || this.user_structure == undefined || this.user_structure.structureId == null || this.user_structure.structureId == undefined) 
                {
                    window.showAlert('res_Msgs_fillUserStructure', 'warning')
                    retVal = false
                }

                if (this.document.sendingEntityId == null || this.document.sendingEntityId == undefined)
                {
                    window.showAlert('res_Msgs_fillSendingEntity', 'warning')
                    retVal = false
                }

                // validate recipient
                if (this.document.compoRecipientDesignatedPersons == null || this.document.compoRecipientDesignatedPersons == undefined || this.document.compoRecipientDesignatedPersons.length == 0)
                {
                    window.showAlert('res_Msgs_fillRecipient', 'warning')
                    retVal = false
                } 

                if (this.document.priority == null || this.document.priority.id == undefined)
                {
                    window.showAlert('res_Msgs_fillPriority', 'warning')
                    retVal = false
                }
                //Committee Required 
                if (constants.isMOMEnabled &&  this.document.categoryId== 6 && (this.document.Committee == null || this.document.Committee.id == undefined))
                {
                    window.showAlert('res_Msgs_fillCommittee', 'warning')
                    retVal = false
                }

                if (this.document.privacy == null || this.document.privacy.id == undefined)
                {
                    window.showAlert('res_Msgs_fillPrivacy', 'warning')
                    retVal = false
                }

                if(constants.client_version_Id == 'NLA' && this.document.classificationPlanId == null && this.document.categoryId == 2)
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    retVal = false;
                }

                if (constants.showDocumentType)
                {
                    if (this.document.documentType == null || this.document.documentType.id == undefined)
                    {
                        window.showAlert('res_Msgs_fillDocumentType', 'warning')
                        retVal = false	
                    }
                }
				
                if (this.document.date == null || this.document.date == undefined || this.document.date == '')
                {
                    if (constants.isMOMEnabled &&  this.document.categoryId== 6 )
                        window.showAlert('res_Msgs_fillMeetingDate', 'warning')
                    else
                        window.showAlert('res_Msgs_fillDocumentDate', 'warning')
                    retVal = false
                }

                if (this.document.subject == null || this.document.subject == undefined || this.document.subject == '')
                {
                    if (constants.isMOMEnabled &&  this.document.categoryId== 6 )
                        window.showAlert('res_Msgs_fillMeetingTitle', 'warning')
                    else
                        window.showAlert('res_Msgs_fillSubject', 'warning')
                    retVal = false
                }
                else 
                {
                    if (this.document.subject.length > 350) 
                    {
                        window.showAlert("Subject field can't be more than 350 characters", 'warning')
                        return false
                    }
                }

                if (this.document.categoryId == 1)
                {
                    if (this.document.externalReferenceNumber == null || this.document.externalReferenceNumber == undefined || this.document.externalReferenceNumber == '')
                    {
                        window.showAlert('res_Msgs_fillExternalReferenceNumber', 'warning')  
                        retVal = false
                    }
                }

                if (this.document.categoryId == 3 && this.selectedTemplate != undefined && this.selectedTemplate.isWorkflow == true) 
                {
                    if (this.document.signers == null || this.document.signers == undefined || this.document.signers.length == 0)
                    {
                        window.showAlert('res_Msgs_fillSigners', 'warning')     
                        retVal = false
                    }
                    else 
                    {
                        this.document.signers.forEach(element => 
                        {
                            if (element == undefined || element.name == undefined || element.name == '')
                            {
                                window.showAlert('res_Msgs_fillSigners', 'warning')     
                                retVal = false
                            }
                        });
                    }
                }

                return retVal;
            },
            clearBlockSelections() {
                this.showTranslatedSubjectBlock = false
                this.showKeywordsBlock = false
                this.showOtherAttachmentsBlock = false
            },
             notifyEmailCorrespondence(value,isTaskReminder) {
               this.notifySubject = "Correspondence subject: " + this.subject;
                this.notifyEmailDialogCorrespondence = value;
                this.isMOM=isTaskReminder;
                
            },
            applyChanges() {
                if (this.isFormValid()) {
                    if (JSON.stringify(this.document.signers) != this.documentSignersBackup && this.document.categoryId != 1) {
                        window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_preconfiguredSignatuesAlert'),
                            () => { this.SaveDocumentCallApi() },
                            () => { })
                    }
                    else {
                        this.SaveDocumentCallApi();
                    }
                }
            },
            SaveDocumentCallApi() {
                //dynamic forms getting data 
                //structure
                var byStructureAndCategory = new FormBuilderUtil([]);
                var filterByStructureIdAndCategoryId = this.filterByStructureIdAndCategoryId;
                byStructureAndCategory.invoke(filterByStructureIdAndCategoryId, this.byStructureAndCategoryHandler);
             
                //template
                var byTemplate = new FormBuilderUtil([]);
                var filterByTemplateId = this.filterByTemplateId;
                byTemplate.invoke(filterByTemplateId, this.byTemplateHandler);

                var model = this.prepareFormDataObject(true)
                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/Save', model)
                    .then(res => {
                        if (res == undefined || res.data == null) {
                            window.hideLoading();
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                        }
                        else if (res.data == "ExternalReferencedNumberInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_SameLetterExist", "warning")
                        }
                        else if (res.data == "OriginalFileInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_ErrorFileCheckedOut", "warning")
                        }
                        else {
                            axios.get(constants.baseApiUrl + 'Document/save-custom?documentId=' + this.documentId)
                                .then(res => {
                                    if (res == undefined || res.data == null) {
                                        window.hideLoading();
                                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                                    }
                                    else {
                                        window.showAlert('res_Msgs_DocumentSavedSuccess', 'success')
                                        this.getDocumentWithTransfer()
                                        this.refreshViewer()
                                    }
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
                        }
                    })
                    .catch(err => { this.handleError(err); window.hideLoading(); })
            },
            CapitalizeFirstLetter(str) {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options) {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            uploadScan(imageData){
                var requestData = {
                documentId: this.documentId,
                name: this.referenceNumber,
                updateFileData: imageData,
                storageAttachmentId: 0,
                count: 0
            }

            const headers2 = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
            };

            window.showLoading();
            axios.post(constants.baseApiUrl + 'Document/UploadScan', requestData, { headers: headers2 })
                .then((res) => {
                    if (res.data == true) 
                    {
                         window.showAlert("Updated Successfuly", "success")
                         this.getDocumentWithTransfer();
                         this.$refs.attachmentCtrl.getAttachments()
                         this.refreshViewer()
                         this.openScanDialog = false;
                    }
                    else
                     {
                         window.showAlert("Document Can't Be modified", "warning")
                     }
                })
                .catch(err => alert(err))
                .finally(() => { window.hideLoading(); });
            },

 
            
            ApproveDocument(){
                axios.get(constants.baseApiUrl + 'Document/ApproveDocument?documentId=' + this.documentId+'&delegationId='+this.delegationId)
                                .then(res => {
                                    if (res == undefined || res.data == null) {
                                        window.hideLoading();
                                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                                    }
                                    else {
                                        window.showAlert('res_Msgs_DocumentApprovedSuccess', 'success')
                                        this.getDocumentWithTransfer()
                                        this.refreshViewer()
                                    }
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
            } 
            ,
            signDocument() {
                this.propertyBag.documentId = this.documentId
                this.propertyBag.transferId = this.transferId
                this.propertyBag.delegationId = this.delegationId

                this.isUAEPassEnabled = constants.signUsingUAEPassEnabled && ((this.document.isUAEPassEnabled != null && this.document.isUAEPassEnabled) || this.document.templateId == null || this.document.templateId == "")
                this.isDocusignEnabled = constants.signUsingDocusignEnabled

                if (this.isUAEPassEnabled || this.isDocusignEnabled)
                    this.selectSignMethodFormDialog = true
                else
                    this.signFormDialog = true
            },
            closeSignFormDialog() {
                this.signFormDialog = false
            },
            closeSelectSignMethodFormDialog() {
                this.selectSignMethodFormDialog = false
            },
            refreshAfterClosingSignDialog() {
                this.signFormDialog = false
                this.refreshViewer()
                this.$refs.attachmentCtrl.getAttachments()
                this.getDocumentWithTransfer()
            },
            refreshAfterClosingSignMethodSelect() {
                this.selectSignMethodFormDialog = false
                this.refreshViewer()
                this.$refs.attachmentCtrl.getAttachments()
                this.getDocumentWithTransfer()
            },
            closeSignMethodSelectAndOpenSignWithPin() {
                this.selectSignMethodFormDialog = false
                this.selectSignMethodFormDialog = false
                this.signFormDialog = true
            },
            previewSignature() 
            {
                this.previewSignatureDialog = true
            },
            closeReviewSignatureDialog() 
            {
                this.previewSignatureDialog = false
            },
            OpenTransferForm(action, workflowId = 0) 
            {  
                this.forwardCc = false
                this.rejected = false
                this.recipientDisabled = false
                this.hideTransferCC=false
                this.readOnlyPurpose=false
                this.signForm = false
                this.transferFormType = 'Transfer'
                if (action == 'Endorse') 
                {
                    this.disablere
                    this.transferFormType = 'Endorse'
                    this.transferSuccessMessage = 'res_Msgs_DocumentEndorsed'
                    this.transferFormHeader = window.translate("res_MenuItems_Endorse")
                    if (constants.client_version_Id == 'ADHA') {
                        this.purpose = { id: 0, name: '' }
                    }
                    else 
                    {
                        this.purpose = { id: 8, name: 'For Signature' }
                    }
                    this.getNextReceiver(false, true)
                }
                else if (action == 'Forward') 
                { 
					this.workflowIdForTransfer = workflowId; 
                    this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                    this.checkForAttachmentsUploadMultiApproval = true
                    this.transferFormHeader = window.translate("res_MenuItems_Forward")
                    if (constants.client_version_Id == 'ADHA') 
                    {
                        this.purpose = { id: 0, name: '' }
                    }
                    if(this.document.categoryId==6 && this.document.purposeId==7 &&this.transferId != null && this.transferId != undefined&&this.transferId!=0)
                    {
                        if(this.isLanguageEn)
                         this.purpose = { id: 11, name:'Approved'  }
                         else  
                          this.purpose = { id: 11, name:'تمت الموافقة'  }
                    } else 
                    {   
                        if(this.isLanguageEn)
                        this.purpose = { id: 3, name: 'For Action' }  
                        else  
                        this.purpose = { id: 3, name: 'لإجراء اللازم' }                
                    }
                    this.getNextReceiver(false, false)
                }
                else if (action == 'SendCC')
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                    this.transferFormHeader = window.translate("res_MenuItems_SendCC")
                    this.purpose = { id: 10, name: 'CCed' }
                    this.hideTransferCC=true
                    this.readOnlyPurpose=true
                }
                else if (action == 'ForwardCc') 
                {
					this.workflowIdForTransfer = workflowId; 
                    this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                    this.checkForAttachmentsUploadMultiApproval = true
                    this.transferFormHeader = window.translate("res_MenuItems_Forward")
                    this.purpose = { id: 10, name: 'Cced' }
                    this.forwardCc=true
                }
                else if (action == 'Sign') 
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentSignedAndSent'
                    this.transferFormHeader = window.translate("res_ButtonText_SignAndSend")

                    this.isUAEPassEnabled = constants.signUsingUAEPassEnabled && ((this.document.isUAEPassEnabled != null && this.document.isUAEPassEnabled) || this.document.templateId == null || this.document.templateId == "")
                    this.isDocusignEnabled = constants.signUsingDocusignEnabled

                    this.signForm = true
                    this.getNextReceiver(true, false)
                }
                else if (action == 'Rejected') 
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentRejected'
                    this.rejected = true
                    this.signForm = utils.checkCanSignDocument(this.document, this.delegationId, this.document.canSign)
                    this.recipientDisabled = true
                    this.transferFormHeader = window.translate("res_MenuItems_Reject")
                    this.purpose = { id: 12, name: 'Rejected' }
                    this.GetInitiator(this.documentId)
                }
                else if (action == 'Send Back') 
                {
                    this.transferSuccessMessage = 'res_Msgs_DocumentSentBack'
                    this.transferFormHeader = window.translate("res_MenuItems_SendBack")
                    if (constants.client_version_Id == 'ADHA') 
                    {
                        this.purpose = { id: 0, name: '' }
                        this.recipientDisabled = false
                    }
                    else 
                    {
                        this.purpose = { id: 3, name: 'For Action' }
                        this.recipientDisabled = true
                    }
                    
                    this.signForm = false
                    this.GetPreviousSender(this.transferId)
                }

               let missingOtherAttachments = this.document.otherAttachments == null || this.document.otherAttachments.trim() == '';
		       let missinglinkedDocuments  = this.linkedDocuments == null || this.linkedDocuments.length == 0;

                if( window.enableConfirmOntransferOtherInfo == true  &&
                    (missinglinkedDocuments|| missingOtherAttachments) &&
                    (this.transferId <= 0 || this.transferId == null) && this.document.categoryId == 2
                ){ 
                    let missingData = [];
                    if(missinglinkedDocuments)
                    { missingData.push(this.$t('res_CardHeaders_LinkedEmails')); }
                    if(missingOtherAttachments)
                    { missingData.push(this.$t('res_Label_OtherAttachments')); }  
                    let customMessage = missingData.length == 1 ? missingData[0] : `(${missingData.join(',')})`; 
                    window.showInformation(
                    this.$t('res_Msgs_Confirmation'),
                    this.$t('res_Msgs_DocumentHasNoLinkedDocsAndOtherAttachments', { customMessage }),
                    () => { this.transferFormDialog = true },
                    () => {})
                }
                else{
                    this.transferFormDialog = true
                }
            },
            OpenWorkflowTransferForm()
            {
                this.workflowTransferFormDialog = true
            },
            PublishToMultiDocument() {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.documentId + '&transferId=' + this.transferId)
                    .then(res => {
                        if (res.data == 1) {
                            window.hideLoading()
                            window.showInformation(
                                window.translate("res_ButtonText_PublishToMultiDocument"),
                                window.translate("res_Msgs_PublishToMultiDocumentConfirmation"),
                                () => {
                                    window.showLoading()
                                    axios.get(constants.baseApiUrl + 'Document/PublishToMultiDocument?documentId=' + this.documentId)
                                        .then(res => {
                                            window.hideLoading()
                                            window.showAlert('res_Msg_PublishedSuccessfully', 'warning')
                                        })
                                        .catch(error => {
                                            console.log(error)
                                            window.hideLoading()
                                        })
                                },
                                () => { });
                        }
                        else {
                            window.hideLoading()
                            window.showAlert('res_Msg_CannotPublish', 'warning')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        window.hideLoading()
                    })

            },
            getNextReceiver(isSign, isEndorse, isRejected) { 
                this.transferCC = []
                this.transferTo = {};
                this.transferToMulti = []

                utils.defaultGet('Transfer/GetDocumentNextDefaultReceiver?docId=' + this.documentId + '&isSign=' + isSign + '&isEndorse=' + isEndorse +
                 '&delegationId=' + this.delegationId+'&purpose='+null,
                    (res) => {
                        if (res.data != null && res.data != undefined) {
                            if (res.data.length > 0 && res.data[0].id != 0) {
                                var isMultiForwardEnabled = false
                                var notCcedElements = res.data.filter(x => x.isCced == false)
                                if (notCcedElements.length > 1)
                                    isMultiForwardEnabled = true
                                res.data.forEach(element => {
                                    var purposeName = ''
                                    var selectedPurpose = constants.purposes.find(x => x.id == element.purpose)
                                    if (selectedPurpose != undefined && selectedPurpose != null) {
                                        purposeName = selectedPurpose.name
                                        if (constants.client_version_Id == 'ADHA') {
                                          this.purpose = { id: 0, name: '' }
                                        }  
                                        else{
                                            this.purpose = { id: element.purpose, name: purposeName }
                                         if(this.document.categoryId==6 && this.document.purposeId==7 &&this.transferId != null && this.transferId != undefined&&this.transferId!=0)
                                            {
                                                //this.purpose = { id: 11, name:'Approved'  }
                                                if(this.isLanguageEn)
                                                this.purpose = { id: 11, name:'Approved'  }
                                                else  
                                                this.purpose = { id: 11, name:'تمت الموافقة'  }
                                                var res = [...this.allTransferPurposes];
                                                
                                                const filterValues = ['Approved', 'Rejected'];

                                                // Use the filter method to get the specific values
                                                const filteredPurposes = [...this.allTransferPurposes].filter(purpose => filterValues.includes(purpose.name));
                                                this.mom_purpose_items =filteredPurposes;
                                                console.log(" this.mom_purpose_items:"+ this.mom_purpose_items);
                                            }
                                        }                                        
                                    }
                                    if (element.isCced)
                                        this.transferCC.push(element)
                                    else {
        
                            
                                        if(this.document.categoryId==6 && this.document.purposeId==7 &&this.transferId != null && this.transferId != undefined&&this.transferId!=0)
                                        {
                                            this.GetInitiator(this.documentId)

                                        }
                                        else{

                                        if (element.name != "0") {
                                            if (isMultiForwardEnabled == false)
                                                this.transferTo = element
                                            else
                                                this.transferToMulti.push(element)
                                        }}
                                    }
                                });
                                if (this.transferCC.length > 0) {
                                    this.transferCC = this.handleFirstElement(this.transferCC, {});
                                }

                                if (this.transferToMulti.length > 0) {
                                    this.transferToMulti = this.handleFirstElement(this.transferToMulti, { name: 'temp', isTemp: true });
                                } else {
                                    this.transferToMulti = []
                                }

                            }
                        }
                    }, this.handleError, true);
            },
            GetPreviousSender(transferId) {
                utils.defaultGet('Transfer/GetPreviousSender?transferId=' + transferId,
                    (res) => {
                        if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                            this.transferTo = res.data
                        }
                    }, this.handleError, true);
            },
            GetInitiator(documentId) {
                utils.defaultGet('Transfer/GetInitiator?documentId=' + documentId,
                    (res) => {
                        if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                            this.transferTo = res.data
                        }
                    }, this.handleError, true);
            },
            openSigningHistory() {
                this.signingHistoryDialog = true
            },
           openVisualTracking() { 
                if (window.enableVisualTracker2 == true) { 
                    this.visualTrackingDialogNew_selectedDocumentId = this.documentId;
                    this.visualTrackingDialogNew = true;  
                }
                else
                { 
                    this.signingHistoryDialog = false
                    // this.visualTrackingDialog = true 
                    var lang = localStorage.getItem('lang')
                    lang = ((lang == null || lang == undefined) ? 'en' : lang);
                    window.setVisualTrackingData(this.documentId);
                    this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                    window.open(this.trackingFrameSrc, "_blank");
                }
            },
            openCompleteDocumentDialog() {
                this.completeDocument_noteText = ''
                this.completeDocumentDialog = true
            },
            completeDocument() {
                if (this.completeDocument_noteText.trim().length == 0) {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return
                }

                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckUserHavePermissionOnDocument?documentId=' + this.documentId)
                    .then(res => {
                        if (res.data == 1) {
                            var body = { documentId: this.documentId, transferId: this.transferId, instructions: this.completeDocument_noteText };

                            axios.post(constants.baseApiUrl + 'Document/CompleteDocument', body, { headers: constants.headers })
                                .then(res => {
                                    window.showAlert('res_Msgs_DocumentCompletedSuccess', 'success')
                                    this.closeDialog(false, false)
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
                        }
                        else {
                            window.hideLoading()
                            window.showAlert('res_Msgs_DocumentNotArchived', 'warning')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        window.hideLoading()
                        this.completeDocumentDialog = false
                    })
            },
            Complete()
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.documentId + '&transferId=' + this.transferId)
                    .then(res => 
                    {
                        if (res.data == 1) 
                        {
                            window.showInformation('Confirmation', window.translate("res_Msgs_TransferCompleteConfirmation"),
                                () => 
                                {
                                    window.showLoading()
                                    axios.get(constants.baseApiUrl + 'Transfer/DismissCcedTransfer?transferId=' + this.transferId)
                                        .then(res => 
                                        {
                                            if (res.data != null && res.data > 0) 
                                            {
                                                window.showAlert('res_Msgs_TransferCompleted', 'success')
                                                this.closeDialog(false, false)
                                            }
                                        })
                                        .catch(error => console.log(error))
                                        .finally(() => window.hideLoading())
                                });
                        }
                        else
                        {
                            window.hideLoading()
                            window.showAlert('res_Msgs_TransferNotCompleted', 'warning')
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            async GetTransferIdForLinkedDocument(documentId)
            {
                try {
                    const res = await axios.get(constants.baseApiUrl + 'LinkedDocument/GetTransferIdForLinkedDocument?documentId=' + documentId)
                    return res.data
                } catch (error) {
                    console.log(error);
                    return null
                }
            },
            async displayLinkedItem(item) {
                if (!item || item.linkedDocumentId == null || item.linkedDocumentId === '')
                    return
                this.viewingLinkedDocument = true
                this.linkedDelegationId = 0
                this.linkedDocumentId = Number(item.linkedDocumentId)

                const fallbackTransferId = item.transferId != null && item.transferId !== '' ? Number(item.transferId) : 0
                const fromApi = await this.GetTransferIdForLinkedDocument(this.linkedDocumentId)
                const resolvedTid = fromApi != null && fromApi !== '' ? Number(fromApi) : fallbackTransferId
                this.linkedTransferId = Number.isFinite(resolvedTid) ? resolvedTid : fallbackTransferId

                let allowed = false
                try {
                    const response = await axios.get(constants.baseApiUrl + 'LinkedDocument/CheckUserAllawedToViewDocuments?linkedDocumentId=' + this.linkedDocumentId)
                    allowed = response.data !== false
                } catch (e) {
                    console.log(e)
                    allowed = false
                }

                if (!allowed) {
                    window.showAlert(this.$t('res_Msg_NotAllowedToOpenLinkedMail'), 'warning')
                    this.viewingLinkedDocument = false
                    return
                }

                this.linkedCorrespondenceDepth++
                this.correspondenceDialog = true
            },
            openLinkedEmailDeleteConfirmation(item) 
            {
                this.linkedDocumentId = item;
                this.LinkedEmailDeleteDialog = true;
            },
            cancelLinkedEmailDeleteDialog() {
                this.LinkedEmailDeleteDialog = false;
            },
            deleteLinkedDocument() 
            {
                axios.get(constants.baseApiUrl + 'LinkedDocument/DeleteLinkedDocument?id=' +  + this.linkedDocumentId + '&documentId=' + this.documentId)
                    .then(response => 
                    {
                        if (response != null) 
                        {
                            this.getLinkedDocuments()
                            this.LinkedEmailDeleteDialog = false
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getUserById(userId) {
                axios.get(constants.baseApiUrl + 'User/GetSelectedUserById?userId=' + userId)
                    .then(response => {
                        if (response.data != null) {
                            return response.data.firstName + response.data.lastName;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            getLinkedDocuments() 
            {
                this.numberOfLinkedDocumentsToDisplay = this.defaultNumberOfLinkedDocumentsToDisplay
                this.linkedDocuments = []
                this.linkedDocumentsFullList = []

       
                axios.get(constants.baseApiUrl + 'LinkedDocument/GetLinkedDocuments?documentId=' + this.documentId)
                    .then(response => 
                    {
                    
                        response.data.forEach(linkedDocument => {
                            var linkedDoc = {
                                id: linkedDocument.id,
                                isEditable: linkedDocument.isEditable,
                                linkedDocumentId: linkedDocument.linkedDocumentId,
                                transferId: linkedDocument.transferId,
                                subject: linkedDocument.subject,
                                name: linkedDocument.userName,
                                referenceNumber: linkedDocument.referenceNumber,
                                createdDate: linkedDocument.createdDate,
                                createdByUser: linkedDocument.createdByUser,
                                createdByUserId: linkedDocument.createdByUserId,
                                documentId: this.documentId
                            }

                            if (this.linkedDocuments.length < this.defaultNumberOfLinkedDocumentsToDisplay)
                                this.linkedDocuments.push(linkedDoc)

                            this.linkedDocumentsFullList.push(linkedDoc)
                        })
                 
                    })
                    .catch(error => console.log(error))
            },
            byStructureAndCategoryHandler(event) 
            {
                this.collectDynamicFormsData.documentId = this.documentId;
                this.collectDynamicFormsData.jsonValuesByStructure = JSON.stringify(event.detail.data);
                axios.post(constants.baseApiUrl+'DynamicForms/UpdateDocumentDynamicForm',this.collectDynamicFormsData)
                    .then(response => { })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            byCategoryHandler(event) 
            {
                this.collectDynamicFormsData.documentId = this.documentId;
                this.collectDynamicFormsData.jsonValuesByCategory = JSON.stringify(event.detail.data);
                axios.post(constants.baseApiUrl+'DynamicForms/UpdateDocumentDynamicForm',this.collectDynamicFormsData)
                    .then(response => { })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            byTemplateHandler(event) {
            this.collectDynamicFormsData.documentId = this.documentId;
            this.collectDynamicFormsData.jsonValuesByTemplate = JSON.stringify(event.detail.data);
            axios.post(constants.baseApiUrl+'DynamicForms/UpdateDocumentDynamicForm',this.collectDynamicFormsData).then(response => {
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            viewAllLinkedDocuments() {
                if (this.numberOfLinkedDocumentsToDisplay == 1000) {
                    this.numberOfLinkedDocumentsToDisplay = this.defaultNumberOfLinkedDocumentsToDisplay
                    this.linkedDocuments = this.linkedDocumentsFullList.slice(0, this.defaultNumberOfLinkedDocumentsToDisplay)
                }
                else {
                    this.numberOfLinkedDocumentsToDisplay = 1000
                    this.linkedDocuments = this.linkedDocumentsFullList
                }
            },
            closeSelectLinkedDocumentPopup() {
                this.linkedDocumentDialog = false;
                this.getLinkedDocuments();
                this.$refs.linkedDocument.reset();

            },
            addLinkedDocuments() {
                this.linkedDocumentDialog = true;
            },
            downloadWithAttachments() {
                   utils.DownloadFile(constants.baseApiUrl + 'Document/DownloadWithAttachments?documentId=' + this.documentId, this.document.subject + '-' + this.document.referenceNumber + '.pdf')                                                        
            },
            downloadwithoutsignture(){
                axios({
                    url: constants.baseApiUrl + "Document/Downloadwithoutheaderandsignture?documentId=" + this.documentId,
                    method: "GET",
                    responseType: "blob", // important
                })
				.then((res) => {
					var blob = new Blob([res.data], { type: "application/octetstream" });

					const link = window.URL.createObjectURL(blob);

					const a = document.createElement("a");
                    a.setAttribute("download",this.document.subject + '-' + this.document.referenceNumber + ".pdf");                   
					
					a.setAttribute("href", link);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				})
				.catch((error) => {
					console.log(error);
					window.hideLoading();
				});        
            },
            downloadAttachmentWithStamps() {
                axios.get(constants.baseApiUrl + 'ViewerActions/DownloadWithAnnotation?id=' + this.attachmentId, {responseType: 'blob'})
                .then(response => {
                    const href = window.URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', this.document.subject + '-' + this.document.referenceNumber + '.pdf'); //or any other extension                                    
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(href);
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
            },
            printWithAttachments() {
                utils.PrintFile(constants.baseApiUrl + 'Document/DownloadWithAttachments?documentId=' + this.documentId, 'print.pdf')
            },
            createCopyFromLetter() {
                window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Msgs_copyLetterAlert'),
                    () => {
                        window.showLoading()
                        axios.post(constants.baseApiUrl + 'Document/CreateCopy?documentId=' + this.documentId)
                            .then(response => {
                                if (response.data != null) {
                                    var newDocumentId = response.data
                                    this.closeDialog(false, false)
                                    window.openNewCorrespondenceDialog(newDocumentId)
                                }
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
                    },
                    () => { });
            },
            printBarcode() 
            {
                const newWindow = window.open();
                var img = new Image();
                img.src = this.barcodeImage;
                newWindow.document.body.appendChild(img);
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            },
            ViewBarcode() 
            {
                if (this.document.referenceNumber && this.document.referenceNumber.indexOf("Code/") !== 0 && this.document.referenceNumber.slice(-1) !== "/") 
                {
                    var date = this.document.createdDate.split(' ')

                    this.loading = true
                    axios.get(constants.baseApiUrl + 'Document/GetBarcode?docReference=' + this.document.referenceNumber + '&datetime=' + date[0] + '&timeOnly=' + date[1])
                        .then(response => {
                            this.barcodeFormDialog = true
                            this.barcodeImage = "data:image/jpg;base64," + response.data;
                            this.loading = false
                        })
                        .catch(error => {
                            console.log(error)
                            this.loading = false
                        }

                        )
                        .finally(() => this.loading = false);
                }
                else {
                    window.showAlert('res_Msgs_CorrespondenceDontHaveReferenceNumber', 'error')
                }
            },
            hideBarCode() {
                this.barcodeFormDialog = false
            },
            isSendBackEnabled() {
                // 8: For Signature, 15: For Endorsement
                return (this.document.isRegistered === true && this.document.cCed == false)
            },
            isRejectEnabled() {
                // 8: For Signature, 15: For Endorsement
                return (this.document.isRegistered === true && this.document.categoryId != 1 && this.IsCced() == false && (this.document.purposeId === 8 || this.document.purposeId === 3))
            },
            canAddEditAttachments() {
                if (this.document.purposeId == 10)
                    return false

                if (this.viewMode == "edit" || this.viewMode == "edit_new")
                    return true

                return false
            },
            canAddEditLinkedDocuments() {
                if (this.document.purposeId == 10 || this.document.statusId == 5)
                    return false

                if (this.viewMode == "edit" || this.viewMode == "edit_new")
                    return true;

                return false;
            },
            canAddEditNotes() {
                if (this.document.purposeId == 10)
                    return false

                if (this.viewMode == "edit" || this.viewMode == "edit_new")
                    return true

                return false
            },
            recall() {
                window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_TransferRecallConfirmation"),
                    () => {
                        utils.defaultPost('Document/Recall?transferId=' + this.transferId, null,
                            (res) => {
                                if (res.data.item1 == true) {
                                    window.showAlert('res_Msgs_TransferRecalled', 'success')
                                    this.closeDialog(false, false)
                                }
                                else {
                                    window.showAlert('res_Msgs_TransferRecallFailed', 'warning')
                                }
                            }, this.handleError, true);
                    },
                    () => { })
            },
            signeesOnDrop(dropResult) {
                this.document.signers = utils.applyDrag(this.document.signers, dropResult)
            },
            canEditDocumentMetaData() {
                return (this.viewMode == 'edit' || this.viewMode == 'edit_new') && (this.document.canUserEdit)
            },
            forceGenerateReferenceNumber() {
                window.showLoading();

                axios.post(constants.baseApiUrl + 'Document/ForceGenerateReferenceNumber?documentId=' + this.documentId + '&forcedGereration=' + true.toString(), null)
                    .then((res) => {
                        if (res && res.data == "HasReferenceNumber")
                            window.showAlert(this.$t('res_Msgs_ThisDocumentAlreadyHasReferenceNumber'), 'warning');
                        else
                        {
                            this.refreshViewer();
                            this.getDocumentWithTransfer();
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(()=> { window.hideLoading();})
            },
            addFavoriteDocument(){
                if(this.favoriteName.length == 0){
                    window.showAlert(this.$t('res_Msgs_FillRequired'),"warning")
                    return
                }
                axios.get(constants.baseApiUrl + `Document/AddFavorite?name=${this.favoriteName}&documentId=${this.documentId}`)
                .then((res) => {
                    this.addFavoriteDialog = false;
                    this.checkFavorite();
                    window.showAlert(this.$t('res_Msgs_FavoriteAdded'),"success")
                })
                .catch(error => console.log(error));
            },
            removeFavorite(){
                axios.get(constants.baseApiUrl + `Document/DeleteFavorite?documentId=${this.documentId}`)
                .then((res) => {
                    this.removeFavoriteDialog = false;
                    this.checkFavorite();
                    window.showAlert(this.$t('res_Msgs_FavoriteRemoved'),"success")
                })
                .catch(error => console.log(error));
            },
            checkFavorite(){
                axios.get(constants.baseApiUrl + `Document/CheckFavorite?documentId=${this.documentId}`)
                    .then((res) => {
                        this.isFavorite = false;
                        if (res != null && res != undefined && res.data != null) {
                            if (res.data == true)
                                this.isFavorite = true;
                        }
                })
                .catch(error => console.log(error));
            },
            handleShowReplyDocumentSection(){
                if(!this.showReplyDocumentSection)
                    this.document.replyDocument = null
            },
            dispatchCorrespondence()
            {
                this.dispatchCorrespondenceFormDialog = true
            },
            dispatchCorrespondenceByEmail()
            {
                this.dispatchCorrespondenceByEmailDialog = true
            },
            searchTags(query){
                if(query.length < 2){
                    return
                }
                axios.get(constants.baseApiUrl + `Document/SearchTags?query=${query}`)
                .then(res => {
                    this.tagOptions = res.data;
                })
                .catch(error => console.log(error));

            },
            addTag(tag){
                if(!constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.DocumentTagsAdd.key)){
                    window.showAlert(this.$t('res_Msgs_PermissionAddTags'), "warning")
                    return
                }
                if(tag.length < 2){
                    window.showAlert(this.$t('res_Msgs_MinTwoDigit'), "warning")
                    return
                }
                var newTag = { id: 0, name: tag};
                this.tagOptions.push(newTag);
                this.document.tags.push(newTag);
            },
            openDeliveryNote(document)
            {
                if(!(document.statusId == 3 || document.statusId == 5))
                {
                    window.showAlert(this.$t('res_Msgs_TheCorrespondenceMustBeSignedFirst'), 'warning')
                    return;
                }

                window.showLoading();
                axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' +  this.documentId)
                    .then((res) => 
                    {
                        
                        if (res.data == true)
                        {
                            window.showAlert(this.$t('res_Msgs_DeliveryNoteCreationValidation'), 'warning')
                        }
                        else
                        {
                            this.referenceNumber = document.referenceNumber;
                            this.deliveryNoteDialog = true;
                        }
                    })
                    .catch((err) => { console.log(err); })
                    .finally(()=>{ window.hideLoading(); })
            },
            closeDeliveryNoteDialog()
            {
                this.deliveryNoteDialog = false
            },
            SaveForLater()
            {
                if(this.hideToDate == ''){
                    window.showAlert(this.$t('res_Msgs_FillRequired'),'warning')
                    return
                }
                window.showLoading();
                axios.get(constants.baseApiUrl + 'Document/SaveForLater?transferId=' +  this.transferId + '&toDate=' + this.hideToDate)
                .then((res) => {
                    if(res.data == false){
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    this.hideCorrespondenceDialog = false;
                    this.hideToDate = '';
                    this.hideToDateMenu = false;
                    this.closeDialog(false, false);
                })
                .catch((err) => { console.log(err); })
                .finally(()=>{ window.hideLoading(); })
            },
            filingPlanSelectChanged(obj) {
                this.$set(this.document, 'filingPlanId', obj.id != null ? obj.id : null);
            },
            classificationPlanSelectChanged(obj) {
                this.$set(this.document, 'classificationPlanId', obj.id != null ? obj.id : null);
            },
            resetDocument() {
                window.showLoading();
                axios.patch(constants.baseApiUrl + 'Document/ResetDocument?documentId=' + this.documentId, null)
                    .then((res) => {
                        if (!utils.CheckIfNullOrEmpty(res))
                            window.showAlert('res_Msgs_SuccessTheDocumentHasBeenReset', 'success')
                            this.getDocumentWithTransfer();
                            this.refreshViewer();
                            this.closeDialog(false,false)
                    })
                    .catch(error => console.log(error))
                    .finally(() => { window.hideLoading(); })
            },
            AdvanceRejectWorkflow(document,transferId,endpointRoute) {  
					   if(typeof(document) == 'undefined' || document == null || !document.id || document.id <= 0) { return false; }  
					   window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Label_ApplyworkflowActionConfirm'),
						   () => {
							   window.showLoading()
							   axios.post(
								   `${constants.baseApiUrl}Workflow/${endpointRoute}?documentId=${document.id}&transferId=${transferId}`)
								   .then(response => {
									   if (response.data != null) { 
										   window.showAlert('res_Label_DocumentWorkflowActionSuccessfully', 'success')
										   this.closeDialog(false, false)
									   }
								   })
								   .catch(error => console.log(error))
								   .finally(() => window.hideLoading())
						   },
						   () => { });
			},
             CompleteWorkflow(document,transferId) {  
					if(typeof(document) == 'undefined' || document == null || !document.id || document.id <= 0) { return false; }  
					   window.showInformation(this.$t('res_Label_Alert'), this.$t('res_Label_ApplyworkflowActionConfirm'),
						() => {
							window.showLoading()
							    axios.post(
								   `${constants.baseApiUrl}Workflow/CompleteWorkflow?documentId=${document.id}&transferId=${transferId}`)
								   .then(response => {
									   if (response.data && response.data.success == true) { 
										   window.showAlert('res_Label_DocumentWorkflowActionSuccessfully', 'success')
										   this.closeDialog(false, false)
									   }
								   })
								   .catch(error => console.log(error))
								   .finally(() => window.hideLoading())
					    },
						() => { });
	    },
        onSelectCommittee(selectedItem) {
            this.council_users_items=[];
            this.selectedItems=[];
            const entityGroup = this.Committee_items.find(
				(e) => e.id === selectedItem.id
			);
			this.council_users_items= entityGroup.councilMembers != null ? entityGroup.councilMembers : [];

            //selected all by default
            this.selectedItems = this.council_users_items.map(user => user.id);
            this.council_users_items.forEach(user => {
                user.selected = true;  
                user.Task = '';  
            });

         },
         documenSelectedGuestsChange(items) {
                this.$set(this.document, 'Guests', this.handleFirstElement(items));
            },
        
    },
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

			   
.StartflowBtn
    {
        cursor: pointer !important;
        background-color: #7AD38F !important;
        color:white !important; 
    }
    .AdvanceflowBtn
    {
        cursor: pointer !important;
        background-color: #198754 !important;
        color:white !important;
    }  

    .RejectflowBtn
    {
        cursor: pointer !important;
        background-color:#DE6C6C !important;
        color:white !important;
    }
    .SignflowBtn
    {
        cursor: pointer !important;
        background-color: #7AD390  !important;
        color: white !important;
    }

    .VotingflowBtn
    {
        cursor: pointer !important;
        background-color: #6C757D !important;
        color: white !important;
    }

    .WorkflowActionsDiv button.StartBtn {
		width: 150px !important;
		font-size: 12px !important;
    }

    .WorkflowActionsDiv button i { 
		margin-left: 1px;
        margin-right: 1px;
    }

   .WorkflowActionsDiv button.StartBtn i { 
		margin-left: 5px;
        margin-right: 5px;
    }
    .WorkflowActionsDiv button { 
        width: 110px !important;  
    }   

   .actions_container2 .actions_container3 .WorkflowActionsDiv button.WorkflowAction
    {
        min-width: fit-content;
    } 
    
    .multiselect__select {
        display: none !important;
    }

    .opacity-ghost {
        transition: all .18s ease;
        opacity: 0.8;
    }

    .opacity-ghost-drop {
        opacity: 1;
        background-color: white;
        box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0);
    }

    .opacity-ghost label, .opacity-ghost .v-icon, .opacity-ghost button {
        display: none;
    }

    .opacity-ghost .multiselect__tags {
        background: white !important;
    }


.FullView-Div-DocumentSubject
{ 
     display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
    cursor: default !important;
}
#usersTable {
    max-height: 350px;
    overflow-y: auto;
    overflow-x: hidden;

  display: block;
  table-layout: fixed; /* Ensures columns stay aligned when scrolling */
}
.ckStyle {
    margin-top:0px !important;
}
.ckStyle .v-input__control .v-input__slot{
    background:none !important;
}

#usersTable td:first-child {
  position: relative;

}

#usersTable .custom-task-field.v-text-field--outlined fieldset {
    top: 0px;
}

#usersTable .v-application--is-ltr .custom-task-field.v-text-field--outlined fieldset {
    padding-left: 0px;
}

</style>